export interface ProfessionalActivity {
	value: string;
	label: string;
}

export const PROFESSIONAL_ACTIVITIES: ProfessionalActivity[] = [
	{ value: '9991#CASER#Z', label: 'Jubilado o Jubilada' },
	{ value: '9992#CASER#Z', label: 'Estudiante' },
	{ value: '9993#CASER#Z', label: 'Rentista' },
	{ value: '9994#CASER#Z', label: 'Desempleado o desempleada' },
	{ value: '9995#CASER#Z', label: 'Pensionista' },
	{ value: '1011#CNAE#C', label: 'Procesado y conservación de carne' },
	{ value: '1012#CNAE#C', label: 'Procesado y conservación de volatería' },
	{ value: '1013#CNAE#C', label: 'Elaboración de productos cárnicos y de volatería' },
	{ value: '1021#CNAE#C', label: 'Procesado de pescados, crustáceos y moluscos' },
	{ value: '1022#CNAE#C', label: 'Fabricación de conservas de pescado' },
	{ value: '1031#CNAE#C', label: 'Procesado y conservación de patatas' },
	{ value: '1032#CNAE#C', label: 'Elaboración de zumos de frutas y hortalizas' },
	{ value: '1039#CNAE#C', label: 'Otro procesado y conservación de frutas y hortalizas' },
	{ value: '1042#CNAE#C', label: 'Fabricación de margarina y grasas comestibles similares' },
	{ value: '1043#CNAE#C', label: 'Fabricación de aceite de oliva' },
	{ value: '1044#CNAE#C', label: 'Fabricación de otros aceites y grasas' },
	{ value: '1052#CNAE#C', label: 'Elaboración de helados' },
	{ value: '1053#CNAE#C', label: 'Fabricación de quesos' },
	{ value: '1054#CNAE#C', label: 'Preparación de leche y otros productos lácteos' },
	{ value: '1061#CNAE#C', label: 'Fabricación de productos de molinería' },
	{ value: '1062#CNAE#C', label: 'Fabricación de almidones y productos amiláceos' },
	{
		value: '1071#CNAE#C',
		label: 'Fabricación de pan y de productos frescos de panadería y pastelería'
	},
	{
		value: '1072#CNAE#C',
		label: 'Fabricación de galletas y productos de panadería y pastelería de larga duración'
	},
	{
		value: '1073#CNAE#C',
		label: 'Fabricación de pastas alimenticias, cuscús y productos similares'
	},
	{ value: '1081#CNAE#C', label: 'Fabricación de azúcar' },
	{ value: '1082#CNAE#C', label: 'Fabricación de cacao, chocolate y productos de confitería' },
	{ value: '1083#CNAE#C', label: 'Elaboración de café, té e infusiones' },
	{ value: '1084#CNAE#C', label: 'Elaboración de especias, salsas y condimentos' },
	{ value: '1085#CNAE#C', label: 'Elaboración de platos y comidas preparados' },
	{
		value: '1086#CNAE#C',
		label: 'Elaboración de preparados alimenticios homogeneizados y alimentos dietéticos'
	},
	{ value: '1089#CNAE#C', label: 'Elaboración de otros productos alimenticios n.c.o.p.' },
	{
		value: '1091#CNAE#C',
		label: 'Fabricación de productos para la alimentación de animales de granja'
	},
	{
		value: '1092#CNAE#C',
		label: 'Fabricación de productos para la alimentación de animales de compañía'
	},
	{ value: '1101#CNAE#C', label: 'Destilación, rectificación y mezcla de bebidas alcohólicas' },
	{ value: '1102#CNAE#C', label: 'Elaboración de vinos' },
	{
		value: '1103#CNAE#C',
		label: 'Elaboración de sidra y otras bebidas fermentadas a partir de frutas'
	},
	{
		value: '1104#CNAE#C',
		label: 'Elaboración de otras bebidas no destiladas, procedentes de la fermentación'
	},
	{ value: '1105#CNAE#C', label: 'Fabricación de cerveza' },
	{ value: '1106#CNAE#C', label: 'Fabricación de malta' },
	{
		value: '1107#CNAE#C',
		label:
			'Fabricación de bebidas no alcohólicas; producción de aguas minerales y otras aguas embotelladas'
	},
	{ value: '1200#CNAE#C', label: 'Industria del tabaco' },
	{ value: '1310#CNAE#C', label: 'Preparación e hilado de fibras textiles' },
	{ value: '1320#CNAE#C', label: 'Fabricación de tejidos textiles' },
	{ value: '1330#CNAE#C', label: 'Acabado de textiles' },
	{ value: '1391#CNAE#C', label: 'Fabricación de tejidos de punto' },
	{
		value: '1392#CNAE#C',
		label: 'Fabricación de artículos confeccionados con textiles, excepto prendas de vestir'
	},
	{ value: '1393#CNAE#C', label: 'Fabricación de alfombras y moquetas' },
	{ value: '1394#CNAE#C', label: 'Fabricación de cuerdas, cordeles, bramantes y redes' },
	{
		value: '1395#CNAE#C',
		label:
			'Fabricación de telas no tejidas y artículos confeccionados con ellas, excepto prendas de vestir'
	},
	{
		value: '1396#CNAE#C',
		label: 'Fabricación de otros productos textiles de uso técnico e industrial'
	},
	{ value: '1399#CNAE#C', label: 'Fabricación de otros productos textiles n.c.o.p.' },
	{ value: '1411#CNAE#C', label: 'Confección de prendas de vestir de cuero' },
	{ value: '1412#CNAE#C', label: 'Confección de ropa de trabajo' },
	{ value: '1413#CNAE#C', label: 'Confección de otras prendas de vestir exteriores' },
	{ value: '1414#CNAE#C', label: 'Confección de ropa interior' },
	{ value: '1419#CNAE#C', label: 'Confección de otras prendas de vestir y accesorios' },
	{ value: '1420#CNAE#C', label: 'Fabricación de artículos de peletería' },
	{ value: '1431#CNAE#C', label: 'Confección de calcetería' },
	{ value: '1439#CNAE#C', label: 'Confección de otras prendas de vestir de punto' },
	{
		value: '1511#CNAE#C',
		label: 'Preparación, curtido y acabado del cuero; preparación y teñido de pieles'
	},
	{
		value: '1512#CNAE#C',
		label: 'Fabricación de artículos de marroquinería, viaje y de guarnicionería y talabartería'
	},
	{ value: '1520#CNAE#C', label: 'Fabricación de calzado' },
	{ value: '1610#CNAE#C', label: 'Aserrado y cepillado de la madera' },
	{ value: '1621#CNAE#C', label: 'Fabricación de chapas y tableros de madera' },
	{ value: '1622#CNAE#C', label: 'Fabricación de suelos de madera ensamblados' },
	{
		value: '1623#CNAE#C',
		label:
			'Fabricación de otras estructuras de madera y piezas de carpintería y ebanistería para la construcción'
	},
	{ value: '1624#CNAE#C', label: 'Fabricación de envases y embalajes de madera' },
	{
		value: '1629#CNAE#C',
		label: 'Fabricación de otros productos de madera; artículos de corcho, cestería y espartería'
	},
	{ value: '1711#CNAE#C', label: 'Fabricación de pasta papelera' },
	{ value: '1712#CNAE#C', label: 'Fabricación de papel y cartón' },
	{
		value: '1721#CNAE#C',
		label:
			'Fabricación de papel y cartón ondulados; fabricación de envases y embalajes de papel y cartón'
	},
	{
		value: '1722#CNAE#C',
		label: 'Fabricación de artículos de papel y cartón para uso doméstico, sanitario e higiénico'
	},
	{ value: '1723#CNAE#C', label: 'Fabricación de artículos de papelería' },
	{ value: '1724#CNAE#C', label: 'Fabricación de papeles pintados' },
	{ value: '1729#CNAE#C', label: 'Fabricación de otros artículos de papel y cartón' },
	{ value: '1811#CNAE#C', label: 'Artes gráficas y servicios relacionados con las mismas' },
	{ value: '1812#CNAE#C', label: 'Otras actividades de impresión y artes gráficas' },
	{ value: '1813#CNAE#C', label: 'Servicios de preimpresión y preparación de soportes' },
	{ value: '1814#CNAE#C', label: 'Encuadernación y servicios relacionados con la misma' },
	{ value: '1820#CNAE#C', label: 'Reproducción de soportes grabados' },
	{ value: '1910#CNAE#C', label: 'Coquerías' },
	{ value: '1920#CNAE#C', label: 'Refino de petróleo' },
	{ value: '2011#CNAE#C', label: 'Fabricación de gases industriales' },
	{ value: '2012#CNAE#C', label: 'Fabricación de colorantes y pigmentos' },
	{ value: '2013#CNAE#C', label: 'Fabricación de otros productos básicos de química inorgánica' },
	{ value: '2014#CNAE#C', label: 'Fabricación de otros productos básicos de química orgánica' },
	{ value: '2015#CNAE#C', label: 'Fabricación de fertilizantes y compuestos nitrogenados' },
	{ value: '2016#CNAE#C', label: 'Fabricación de plásticos en formas primarias' },
	{ value: '2017#CNAE#C', label: 'Fabricación de caucho sintético en formas primarias' },
	{ value: '2020#CNAE#C', label: 'Fabricación de pesticidas y otros productos agroquímicos' },
	{
		value: '2030#CNAE#C',
		label:
			'Fabricación de pinturas, barnices y revestimientos similares; tintas de imprenta y masillas'
	},
	{
		value: '2041#CNAE#C',
		label: 'Fabricación de jabones, detergentes y otros artículos de limpieza y abrillantamiento'
	},
	{ value: '2042#CNAE#C', label: 'Fabricación de perfumes y cosméticos' },
	{ value: '2051#CNAE#C', label: 'Fabricación de explosivos' },
	{ value: '2052#CNAE#C', label: 'Fabricación de colas' },
	{ value: '2053#CNAE#C', label: 'Fabricación de aceites esenciales' },
	{ value: '2059#CNAE#C', label: 'Fabricación de otros productos químicos n.c.o.p.' },
	{ value: '2060#CNAE#C', label: 'Fabricación de fibras artificiales y sintéticas' },
	{ value: '2110#CNAE#C', label: 'Fabricación de productos farmacéuticos de base' },
	{ value: '2120#CNAE#C', label: 'Fabricación de especialidades farmacéuticas' },
	{
		value: '2211#CNAE#C',
		label:
			'Fabricación de neumáticos y cámaras de caucho; reconstrucción y recauchutado de neumáticos'
	},
	{ value: '2219#CNAE#C', label: 'Fabricación de otros productos de caucho' },
	{ value: '2221#CNAE#C', label: 'Fabricación de placas, hojas, tubos y perfiles de plástico' },
	{ value: '2222#CNAE#C', label: 'Fabricación de envases y embalajes de plástico' },
	{ value: '2223#CNAE#C', label: 'Fabricación de productos de plástico para la construcción' },
	{ value: '2229#CNAE#C', label: 'Fabricación de otros productos de plástico' },
	{ value: '2311#CNAE#C', label: 'Fabricación de vidrio plano' },
	{ value: '2312#CNAE#C', label: 'Manipulado y transformación de vidrio plano' },
	{ value: '2313#CNAE#C', label: 'Fabricación de vidrio hueco' },
	{ value: '2314#CNAE#C', label: 'Fabricación de fibra de vidrio' },
	{
		value: '2319#CNAE#C',
		label: 'Fabricación y manipulado de otro vidrio, incluido el vidrio técnico'
	},
	{ value: '2320#CNAE#C', label: 'Fabricación de productos cerámicos refractarios' },
	{ value: '2331#CNAE#C', label: 'Fabricación de azulejos y baldosas de cerámica' },
	{
		value: '2332#CNAE#C',
		label: 'Fabricación de ladrillos, tejas y productos de tierras cocidas para la construcción'
	},
	{
		value: '2341#CNAE#C',
		label: 'Fabricación de artículos cerámicos de uso doméstico y ornamental'
	},
	{ value: '2342#CNAE#C', label: 'Fabricación de aparatos sanitarios cerámicos' },
	{
		value: '2343#CNAE#C',
		label: 'Fabricación de aisladores y piezas aislantes de material cerámico'
	},
	{ value: '2344#CNAE#C', label: 'Fabricación de otros productos cerámicos de uso técnico' },
	{ value: '2349#CNAE#C', label: 'Fabricación de otros productos cerámicos' },
	{ value: '2351#CNAE#C', label: 'Fabricación de cemento' },
	{ value: '2352#CNAE#C', label: 'Fabricación de cal y yeso' },
	{ value: '2361#CNAE#C', label: 'Fabricación de elementos de hormigón para la construcción' },
	{ value: '2362#CNAE#C', label: 'Fabricación de elementos de yeso para la construcción' },
	{ value: '2363#CNAE#C', label: 'Fabricación de hormigón fresco' },
	{ value: '2364#CNAE#C', label: 'Fabricación de mortero' },
	{ value: '2365#CNAE#C', label: 'Fabricación de fibrocemento' },
	{ value: '2369#CNAE#C', label: 'Fabricación de otros productos de hormigón, yeso y cemento' },
	{ value: '2370#CNAE#C', label: 'Corte, tallado y acabado de la piedra' },
	{ value: '2391#CNAE#C', label: 'Fabricación de productos abrasivos' },
	{ value: '2399#CNAE#C', label: 'Fabricación de otros productos minerales no metálicos n.c.o.p.' },
	{
		value: '2410#CNAE#C',
		label: 'Fabricación de productos básicos de hierro, acero y ferroaleaciones'
	},
	{
		value: '2420#CNAE#C',
		label: 'Fabricación de tubos, tuberías, perfiles huecos y sus accesorios, de acero'
	},
	{ value: '2431#CNAE#C', label: 'Estirado en frío' },
	{ value: '2432#CNAE#C', label: 'Laminación en frío' },
	{ value: '2433#CNAE#C', label: 'Producción de perfiles en frío por conformación con plegado' },
	{ value: '2434#CNAE#C', label: 'Trefilado en frío' },
	{ value: '2441#CNAE#C', label: 'Producción de metales preciosos' },
	{ value: '2442#CNAE#C', label: 'Producción de aluminio' },
	{ value: '2443#CNAE#C', label: 'Producción de plomo, zinc y estaño' },
	{ value: '2444#CNAE#C', label: 'Producción de cobre' },
	{ value: '2445#CNAE#C', label: 'Producción de otros metales no férreos' },
	{ value: '2446#CNAE#C', label: 'Procesamiento de combustibles nucleares' },
	{ value: '2451#CNAE#C', label: 'Fundición de hierro' },
	{ value: '2452#CNAE#C', label: 'Fundición de acero' },
	{ value: '2453#CNAE#C', label: 'Fundición de metales ligeros' },
	{ value: '2454#CNAE#C', label: 'Fundición de otros metales no férreos' },
	{ value: '2511#CNAE#C', label: 'Fabricación de estructuras metálicas y sus componentes' },
	{ value: '2512#CNAE#C', label: 'Fabricación de carpintería metálica' },
	{ value: '2521#CNAE#C', label: 'Fabricación de radiadores y calderas para calefacción central' },
	{
		value: '2529#CNAE#C',
		label: 'Fabricación de otras cisternas, grandes depósitos y contenedores de metal'
	},
	{
		value: '2530#CNAE#C',
		label: 'Fabricación de generadores de vapor, excepto calderas de calefacción central'
	},
	{ value: '2540#CNAE#C', label: 'Fabricación de armas y municiones' },
	{
		value: '2550#CNAE#C',
		label: 'Forja, estampación y embutición de metales; metalurgia de polvos'
	},
	{ value: '2561#CNAE#C', label: 'Tratamiento y revestimiento de metales' },
	{ value: '2562#CNAE#C', label: 'Ingeniería mecánica por cuenta de terceros' },
	{ value: '2571#CNAE#C', label: 'Fabricación de artículos de cuchillería y cubertería' },
	{ value: '2572#CNAE#C', label: 'Fabricación de cerraduras y herrajes' },
	{ value: '2573#CNAE#C', label: 'Fabricación de herramientas' },
	{ value: '2591#CNAE#C', label: 'Fabricación de bidones y toneles de hierro o acero' },
	{ value: '2592#CNAE#C', label: 'Fabricación de envases y embalajes metálicos ligeros' },
	{ value: '2593#CNAE#C', label: 'Fabricación de productos de alambre, cadenas y muelles' },
	{ value: '2594#CNAE#C', label: 'Fabricación de pernos y productos de tornillería' },
	{ value: '2599#CNAE#C', label: 'Fabricación de otros productos metálicos n.c.o.p.' },
	{ value: '2611#CNAE#C', label: 'Fabricación de componentes electrónicos' },
	{ value: '2612#CNAE#C', label: 'Fabricación de circuitos impresos ensamblados' },
	{ value: '2620#CNAE#C', label: 'Fabricación de ordenadores y equipos periféricos' },
	{ value: '2630#CNAE#C', label: 'Fabricación de equipos de telecomunicaciones' },
	{ value: '2640#CNAE#C', label: 'Fabricación de productos electrónicos de consumo' },
	{
		value: '2651#CNAE#C',
		label: 'Fabricación de instrumentos y aparatos de medida, verificación y navegación'
	},
	{ value: '2652#CNAE#C', label: 'Fabricación de relojes' },
	{
		value: '2660#CNAE#C',
		label: 'Fabricación de equipos de radiación, electromédicos y electroterapéuticos'
	},
	{ value: '2670#CNAE#C', label: 'Fabricación de instrumentos de óptica y equipo fotográfico' },
	{ value: '2680#CNAE#C', label: 'Fabricación de soportes magnéticos y ópticos' },
	{
		value: '2711#CNAE#C',
		label: 'Fabricación de motores, generadores y transformadores eléctricos'
	},
	{ value: '2712#CNAE#C', label: 'Fabricación de aparatos de distribución y control eléctrico' },
	{ value: '2720#CNAE#C', label: 'Fabricación de pilas y acumuladores eléctricos' },
	{ value: '2731#CNAE#C', label: 'Fabricación de cables de fibra óptica' },
	{ value: '2732#CNAE#C', label: 'Fabricación de otros hilos y cables electrónicos y eléctricos' },
	{ value: '2733#CNAE#C', label: 'Fabricación de dispositivos de cableado' },
	{ value: '2740#CNAE#C', label: 'Fabricación de lámparas y aparatos eléctricos de iluminación' },
	{ value: '2751#CNAE#C', label: 'Fabricación de electrodomésticos' },
	{ value: '2752#CNAE#C', label: 'Fabricación de aparatos domésticos no eléctricos' },
	{ value: '2790#CNAE#C', label: 'Fabricación de otro material y equipo eléctrico' },
	{
		value: '2811#CNAE#C',
		label:
			'Fabricación de motores y turbinas, excepto los destinados a aeronaves, vehículos automóviles y ciclomotores'
	},
	{ value: '2812#CNAE#C', label: 'Fabricación de equipos de transmisión hidráulica y neumática' },
	{ value: '2813#CNAE#C', label: 'Fabricación de otras bombas y compresores' },
	{ value: '2814#CNAE#C', label: 'Fabricación de otra grifería y válvulas' },
	{
		value: '2815#CNAE#C',
		label: 'Fabricación de cojinetes, engranajes y órganos mecánicos de transmisión'
	},
	{ value: '2821#CNAE#C', label: 'Fabricación de hornos y quemadores' },
	{ value: '2822#CNAE#C', label: 'Fabricación de maquinaria de elevación y manipulación' },
	{
		value: '2823#CNAE#C',
		label: 'Fabricación de máquinas y equipos de oficina, excepto equipos informáticos'
	},
	{ value: '2824#CNAE#C', label: 'Fabricación de herramientas eléctricas manuales' },
	{
		value: '2825#CNAE#C',
		label: 'Fabricación de maquinaria de ventilación y refrigeración no doméstica'
	},
	{ value: '2829#CNAE#C', label: 'Fabricación de otra maquinaria de uso general n.c.o.p.' },
	{ value: '2830#CNAE#C', label: 'Fabricación de maquinaria agraria y forestal' },
	{ value: '2841#CNAE#C', label: 'Fabricación de máquinas herramienta para trabajar el metal' },
	{ value: '2849#CNAE#C', label: 'Fabricación de otras máquinas herramienta' },
	{ value: '2891#CNAE#C', label: 'Fabricación de maquinaria para la industria metalúrgica' },
	{
		value: '2892#CNAE#C',
		label: 'Fabricación de maquinaria para las industrias extractivas y de la construcción'
	},
	{
		value: '2893#CNAE#C',
		label: 'Fabricación de maquinaria para la industria de la alimentación, bebidas y tabaco'
	},
	{
		value: '2894#CNAE#C',
		label: 'Fabricación de maquinaria para las industrias textil, de la confección y del cuero'
	},
	{
		value: '2895#CNAE#C',
		label: 'Fabricación de maquinaria para la industria del papel y del cartón'
	},
	{
		value: '2896#CNAE#C',
		label: 'Fabricación de maquinaria para la industria del plástico y el caucho'
	},
	{ value: '2899#CNAE#C', label: 'Fabricación de otra maquinaria para usos específicos n.c.o.p.' },
	{ value: '2910#CNAE#C', label: 'Fabricación de vehículos de motor' },
	{
		value: '2920#CNAE#C',
		label:
			'Fabricación de carrocerías para vehículos de motor; fabricación de remolques y semirremolques'
	},
	{
		value: '2931#CNAE#C',
		label: 'Fabricación de equipos eléctricos y electrónicos para vehículos de motor'
	},
	{
		value: '2932#CNAE#C',
		label: 'Fabricación de otros componentes, piezas y accesorios para vehículos de motor'
	},
	{ value: '3011#CNAE#C', label: 'Construcción de barcos y estructuras flotantes' },
	{ value: '3012#CNAE#C', label: 'Construcción de embarcaciones de recreo y deporte' },
	{ value: '3020#CNAE#C', label: 'Fabricación de locomotoras y material ferroviario' },
	{ value: '3030#CNAE#C', label: 'Construcción aeronáutica y espacial y su maquinaria' },
	{ value: '3040#CNAE#C', label: 'Fabricación de vehículos militares de combate' },
	{ value: '3091#CNAE#C', label: 'Fabricación de motocicletas' },
	{
		value: '3092#CNAE#C',
		label: 'Fabricación de bicicletas y de vehículos para personas con discapacidad'
	},
	{ value: '3099#CNAE#C', label: 'Fabricación de otro material de transporte n.c.o.p.' },
	{
		value: '3101#CNAE#C',
		label: 'Fabricación de muebles de oficina y de establecimientos comerciales'
	},
	{ value: '3102#CNAE#C', label: 'Fabricación de muebles de cocina' },
	{ value: '3103#CNAE#C', label: 'Fabricación de colchones' },
	{ value: '3109#CNAE#C', label: 'Fabricación de otros muebles' },
	{ value: '3211#CNAE#C', label: 'Fabricación de monedas' },
	{ value: '3212#CNAE#C', label: 'Fabricación de artículos de joyería y artículos similares' },
	{ value: '3213#CNAE#C', label: 'Fabricación de artículos de bisutería y artículos similares' },
	{ value: '3220#CNAE#C', label: 'Fabricación de instrumentos musicales' },
	{ value: '3230#CNAE#C', label: 'Fabricación de artículos de deporte' },
	{ value: '3240#CNAE#C', label: 'Fabricación de juegos y juguetes' },
	{
		value: '3250#CNAE#C',
		label: 'Fabricación de instrumentos y suministros médicos y odontológicos'
	},
	{ value: '3291#CNAE#C', label: 'Fabricación de escobas, brochas y cepillos' },
	{ value: '3299#CNAE#C', label: 'Otras industrias manufactureras n.c.o.p.' },
	{ value: '3311#CNAE#C', label: 'Reparación de productos metálicos' },
	{ value: '3312#CNAE#C', label: 'Reparación de maquinaria' },
	{ value: '3313#CNAE#C', label: 'Reparación de equipos electrónicos y ópticos' },
	{ value: '3314#CNAE#C', label: 'Reparación de equipos eléctricos' },
	{ value: '3315#CNAE#C', label: 'Reparación y mantenimiento naval' },
	{ value: '3316#CNAE#C', label: 'Reparación y mantenimiento aeronáutico y espacial' },
	{ value: '3317#CNAE#C', label: 'Reparación y mantenimiento de otro material de transporte' },
	{ value: '3319#CNAE#C', label: 'Reparación de otros equipos' },
	{ value: '3320#CNAE#C', label: 'Instalación de máquinas y equipos industriales' },
	{ value: '3512#CNAE#D', label: 'Transporte de energía eléctrica' },
	{ value: '3513#CNAE#D', label: 'Distribución de energía eléctrica' },
	{ value: '3514#CNAE#D', label: 'Comercio de energía eléctrica' },
	{ value: '3515#CNAE#D', label: 'Producción de energía hidroeléctrica' },
	{ value: '3516#CNAE#D', label: 'Producción de energía eléctrica de origen térmico convencional' },
	{ value: '3517#CNAE#D', label: 'Producción de energía eléctrica de origen nuclear' },
	{ value: '3518#CNAE#D', label: 'Producción de energía eléctrica de origen eólico' },
	{ value: '3519#CNAE#D', label: 'Producción de energía eléctrica de otros tipos' },
	{ value: '3521#CNAE#D', label: 'Producción de gas' },
	{ value: '3522#CNAE#D', label: 'Distribución por tubería de combustibles gaseosos' },
	{ value: '3523#CNAE#D', label: 'Comercio de gas por tubería' },
	{ value: '3530#CNAE#D', label: 'Suministro de vapor y aire acondicionado' },
	{ value: '3600#CNAE#E', label: 'Captación, depuración y distribución de agua' },
	{ value: '3700#CNAE#E', label: 'Recogida y tratamiento de aguas residuales' },
	{ value: '3811#CNAE#E', label: 'Recogida de residuos no peligrosos' },
	{ value: '3812#CNAE#E', label: 'Recogida de residuos peligrosos' },
	{ value: '3821#CNAE#E', label: 'Tratamiento y eliminación de residuos no peligrosos' },
	{ value: '3822#CNAE#E', label: 'Tratamiento y eliminación de residuos peligrosos' },
	{ value: '3831#CNAE#E', label: 'Separación y clasificación de materiales' },
	{ value: '3832#CNAE#E', label: 'Valorización de materiales ya clasificados' },
	{
		value: '3900#CNAE#E',
		label: 'Actividades de descontaminación y otros servicios de gestión de residuos'
	},
	{ value: '4110#CNAE#F', label: 'Promoción inmobiliaria' },
	{ value: '4121#CNAE#F', label: 'Construcción de edificios residenciales' },
	{ value: '4122#CNAE#F', label: 'Construcción de edificios no residenciales' },
	{ value: '4211#CNAE#F', label: 'Construcción de carreteras y autopistas' },
	{ value: '4212#CNAE#F', label: 'Construcción de vías férreas de superficie y subterráneas' },
	{ value: '4213#CNAE#F', label: 'Construcción de puentes y túneles' },
	{ value: '4221#CNAE#F', label: 'Construcción de redes para fluidos' },
	{ value: '4222#CNAE#F', label: 'Construcción de redes eléctricas y de telecomunicaciones' },
	{ value: '4291#CNAE#F', label: 'Obras hidráulicas' },
	{ value: '4299#CNAE#F', label: 'Construcción de otros proyectos de ingeniería civil n.c.o.p.' },
	{ value: '4311#CNAE#F', label: 'Demolición' },
	{ value: '4312#CNAE#F', label: 'Preparación de terrenos' },
	{ value: '4313#CNAE#F', label: 'Perforaciones y sondeos' },
	{ value: '4321#CNAE#F', label: 'Instalaciones eléctricas' },
	{
		value: '4322#CNAE#F',
		label: 'Fontanería, instalaciones de sistemas de calefacción y aire acondicionado'
	},
	{ value: '4329#CNAE#F', label: 'Otras instalaciones en obras de construcción' },
	{ value: '4331#CNAE#F', label: 'Revocamiento' },
	{ value: '4332#CNAE#F', label: 'Instalación de carpintería' },
	{ value: '4333#CNAE#F', label: 'Revestimiento de suelos y paredes' },
	{ value: '4334#CNAE#F', label: 'Pintura y acristalamiento' },
	{ value: '4339#CNAE#F', label: 'Otro acabado de edificios' },
	{ value: '4391#CNAE#F', label: 'Construcción de cubiertas' },
	{ value: '4399#CNAE#F', label: 'Otras actividades de construcción especializada n.c.o.p.' },
	{ value: '4511#CNAE#G', label: 'Venta de automóviles y vehículos de motor ligeros' },
	{ value: '4519#CNAE#G', label: 'Venta de otros vehículos de motor' },
	{ value: '4520#CNAE#G', label: 'Mantenimiento y reparación de vehículos de motor' },
	{
		value: '4531#CNAE#G',
		label: 'Comercio al por mayor de repuestos y accesorios de vehículos de motor'
	},
	{
		value: '4532#CNAE#G',
		label: 'Comercio al por menor de repuestos y accesorios de vehículos de motor'
	},
	{
		value: '4540#CNAE#G',
		label: 'Venta, mantenimiento y reparación de motocicletas y de sus repuestos y accesorios'
	},
	{
		value: '4611#CNAE#G',
		label:
			'Intermediarios del comercio de materias primas agrarias, animales vivos, materias primas textiles y productos semielaborados'
	},
	{
		value: '4612#CNAE#G',
		label:
			'Intermediarios del comercio de combustibles, minerales, metales y productos químicos industriales'
	},
	{
		value: '4613#CNAE#G',
		label: 'Intermediarios del comercio de la madera y materiales de construcción'
	},
	{
		value: '4614#CNAE#G',
		label: 'Intermediarios del comercio de maquinaria, equipo industrial, embarcaciones y aeronaves'
	},
	{
		value: '4615#CNAE#G',
		label: 'Intermediarios del comercio de muebles, artículos para el hogar y ferretería'
	},
	{
		value: '4616#CNAE#G',
		label:
			'Intermediarios del comercio de textiles, prendas de vestir, peletería, calzado y artículos de cuero'
	},
	{
		value: '4617#CNAE#G',
		label: 'Intermediarios del comercio de productos alimenticios, bebidas y tabaco'
	},
	{
		value: '4618#CNAE#G',
		label: 'Intermediarios del comercio especializados en la venta de otros productos específicos'
	},
	{ value: '4619#CNAE#G', label: 'Intermediarios del comercio de productos diversos' },
	{
		value: '4621#CNAE#G',
		label: 'Comercio al por mayor de cereales, tabaco en rama, simientes y alimentos para animales'
	},
	{ value: '4622#CNAE#G', label: 'Comercio al por mayor de flores y plantas' },
	{ value: '4623#CNAE#G', label: 'Comercio al por mayor de animales vivos' },
	{ value: '4624#CNAE#G', label: 'Comercio al por mayor de cueros y pieles' },
	{ value: '4631#CNAE#G', label: 'Comercio al por mayor de frutas y hortalizas' },
	{ value: '4632#CNAE#G', label: 'Comercio al por mayor de carne y productos cárnicos' },
	{
		value: '4633#CNAE#G',
		label: 'Comercio al por mayor de productos lácteos, huevos, aceites y grasas comestibles'
	},
	{ value: '4634#CNAE#G', label: 'Comercio al por mayor de bebidas' },
	{ value: '4635#CNAE#G', label: 'Comercio al por mayor de productos del tabaco' },
	{ value: '4636#CNAE#G', label: 'Comercio al por mayor de azúcar, chocolate y confitería' },
	{ value: '4637#CNAE#G', label: 'Comercio al por mayor de café, té, cacao y especias' },
	{
		value: '4638#CNAE#G',
		label: 'Comercio al por mayor de pescados y mariscos y otros productos alimenticios'
	},
	{
		value: '4639#CNAE#G',
		label: 'Comercio al por mayor, no especializado, de productos alimenticios, bebidas y tabaco'
	},
	{ value: '4641#CNAE#G', label: 'Comercio al por mayor de textiles' },
	{ value: '4642#CNAE#G', label: 'Comercio al por mayor de prendas de vestir y calzado' },
	{ value: '4643#CNAE#G', label: 'Comercio al por mayor de aparatos electrodomésticos' },
	{
		value: '4644#CNAE#G',
		label: 'Comercio al por mayor de porcelana, cristalería y artículos de limpieza'
	},
	{ value: '4645#CNAE#G', label: 'Comercio al por mayor de productos perfumería y cosmética' },
	{ value: '4646#CNAE#G', label: 'Comercio al por mayor de productos farmacéuticos' },
	{
		value: '4647#CNAE#G',
		label: 'Comercio al por mayor de muebles, alfombras y aparatos de iluminación'
	},
	{ value: '4648#CNAE#G', label: 'Comercio al por mayor de artículos de relojería y joyería' },
	{ value: '4649#CNAE#G', label: 'Comercio al por mayor de otros artículos de uso doméstico' },
	{
		value: '4651#CNAE#G',
		label: 'Comercio al por mayor de ordenadores, equipos periféricos y programas informáticos'
	},
	{
		value: '4652#CNAE#G',
		label: 'Comercio al por mayor de equipos electrónicos y de telecomunicaciones y sus componentes'
	},
	{
		value: '4661#CNAE#G',
		label: 'Comercio al por mayor de maquinaria, equipos y suministros agrícolas'
	},
	{ value: '4662#CNAE#G', label: 'Comercio al por mayor de máquinas herramienta' },
	{
		value: '4663#CNAE#G',
		label:
			'Comercio al por mayor de maquinaria para la minería, la construcción y la ingeniería civil'
	},
	{
		value: '4664#CNAE#G',
		label:
			'Comercio al por mayor de maquinaria para la industria textil y de máquinas de coser y tricotar'
	},
	{ value: '4665#CNAE#G', label: 'Comercio al por mayor de muebles de oficina' },
	{ value: '4666#CNAE#G', label: 'Comercio al por mayor de otra maquinaria y equipo de oficina' },
	{ value: '4669#CNAE#G', label: 'Comercio al por mayor de otra maquinaria y equipo' },
	{
		value: '4671#CNAE#G',
		label:
			'Comercio al por mayor de combustibles sólidos, líquidos y gaseosos, y productos similares'
	},
	{ value: '4672#CNAE#G', label: 'Comercio al por mayor de metales y minerales metálicos' },
	{
		value: '4673#CNAE#G',
		label: 'Comercio al por mayor de madera, materiales de construcción y aparatos sanitarios'
	},
	{ value: '4674#CNAE#G', label: 'Comercio al por mayor de ferretería, fontanería y calefacción' },
	{ value: '4675#CNAE#G', label: 'Comercio al por mayor de productos químicos' },
	{ value: '4676#CNAE#G', label: 'Comercio al por mayor de otros productos semielaborados' },
	{ value: '4677#CNAE#G', label: 'Comercio al por mayor de chatarra y productos de desecho' },
	{ value: '4690#CNAE#G', label: 'Comercio al por mayor no especializado' },
	{
		value: '4711#CNAE#G',
		label:
			'Comercio al por menor en establecimientos no especializados, con predominio en productos alimenticios, bebidas y tabaco'
	},
	{
		value: '4719#CNAE#G',
		label: 'Otro comercio al por menor en establecimientos no especializados'
	},
	{
		value: '4721#CNAE#G',
		label: 'Comercio al por menor de frutas y hortalizas en establecimientos especializados'
	},
	{
		value: '4722#CNAE#G',
		label: 'Comercio al por menor de carne y productos cárnicos en establecimientos especializados'
	},
	{
		value: '4723#CNAE#G',
		label: 'Comercio al por menor de pescados y mariscos en establecimientos especializados'
	},
	{
		value: '4724#CNAE#G',
		label:
			'Comercio al por menor de pan y productos de panadería, confitería y pastelería en establecimientos especializados'
	},
	{
		value: '4725#CNAE#G',
		label: 'Comercio al por menor de bebidas en establecimientos especializados'
	},
	{
		value: '4726#CNAE#G',
		label: 'Comercio al por menor de productos de tabaco en establecimientos especializados'
	},
	{
		value: '4729#CNAE#G',
		label: 'Otro comercio al por menor de productos alimenticios en establecimientos especializados'
	},
	{
		value: '4730#CNAE#G',
		label:
			'Comercio al por menor de combustible para la automoción en establecimientos especializados'
	},
	{
		value: '4741#CNAE#G',
		label:
			'Comercio al por menor de ordenadores, equipos periféricos y programas informáticos en establecimientos especializados'
	},
	{
		value: '4742#CNAE#G',
		label:
			'Comercio al por menor de equipos de telecomunicaciones en establecimientos especializados'
	},
	{
		value: '4743#CNAE#G',
		label: 'Comercio al por menor de equipos de audio y vídeo en establecimientos especializados'
	},
	{
		value: '4751#CNAE#G',
		label: 'Comercio al por menor de textiles en establecimientos especializados'
	},
	{
		value: '4752#CNAE#G',
		label:
			'Comercio al por menor de ferretería, pintura y vidrio en establecimientos especializados'
	},
	{
		value: '4753#CNAE#G',
		label:
			'Comercio al por menor de alfombras, moquetas y revestimientos de paredes y suelos en establecimientos especializados'
	},
	{
		value: '4754#CNAE#G',
		label: 'Comercio al por menor de aparatos electrodomésticos en establecimientos especializados'
	},
	{
		value: '4759#CNAE#G',
		label:
			'Comercio al por menor de muebles, aparatos de iluminación y otros artículos de uso doméstico en establecimientos especializados'
	},
	{
		value: '4761#CNAE#G',
		label: 'Comercio al por menor de libros en establecimientos especializados'
	},
	{
		value: '4762#CNAE#G',
		label:
			'Comercio al por menor de periódicos y artículos de papelería en establecimientos especializados'
	},
	{
		value: '4763#CNAE#G',
		label:
			'Comercio al por menor de grabaciones de música y vídeo en establecimientos especializados'
	},
	{
		value: '4764#CNAE#G',
		label: 'Comercio al por menor de artículos deportivos en establecimientos especializados'
	},
	{
		value: '4765#CNAE#G',
		label: 'Comercio al por menor de juegos y juguetes en establecimientos especializados'
	},
	{
		value: '4771#CNAE#G',
		label: 'Comercio al por menor de prendas de vestir en establecimientos especializados'
	},
	{
		value: '4772#CNAE#G',
		label:
			'Comercio al por menor de calzado y artículos de cuero en establecimientos especializados'
	},
	{
		value: '4773#CNAE#G',
		label: 'Comercio al por menor de productos farmacéuticos en establecimientos especializados'
	},
	{
		value: '4774#CNAE#G',
		label:
			'Comercio al por menor de artículos médicos y ortopédicos en establecimientos especializados'
	},
	{
		value: '4775#CNAE#G',
		label:
			'Comercio al por menor de productos cosméticos e higiénicos en establecimientos especializados'
	},
	{
		value: '4776#CNAE#G',
		label:
			'Comercio al por menor de flores, plantas, semillas, fertilizantes, animales de compañía y alimentos para los mismos en establecimientos especializados'
	},
	{
		value: '4777#CNAE#G',
		label:
			'Comercio al por menor de artículos de relojería y joyería en establecimientos especializados'
	},
	{
		value: '4778#CNAE#G',
		label: 'Otro comercio al por menor de artículos nuevos en establecimientos especializados'
	},
	{
		value: '4779#CNAE#G',
		label: 'Comercio al por menor de artículos de segunda mano en establecimientos'
	},
	{
		value: '4781#CNAE#G',
		label:
			'Comercio al por menor de productos alimenticios, bebidas y tabaco en puestos de venta y en mercadillos'
	},
	{
		value: '4782#CNAE#G',
		label:
			'Comercio al por menor de productos textiles, prendas de vestir y calzado en puestos de venta y en mercadillos'
	},
	{
		value: '4789#CNAE#G',
		label: 'Comercio al por menor de otros productos en puestos de venta y en mercadillos'
	},
	{ value: '4791#CNAE#G', label: 'Comercio al por menor por correspondencia o Internet' },
	{
		value: '4799#CNAE#G',
		label:
			'Otro comercio al por menor no realizado ni en establecimientos, ni en puestos de venta ni en mercadillos'
	},
	{ value: '4910#CNAE#H', label: 'Transporte interurbano de pasajeros por ferrocarril' },
	{ value: '4920#CNAE#H', label: 'Transporte de mercancías por ferrocarril' },
	{ value: '4931#CNAE#H', label: 'Transporte terrestre urbano y suburbano de pasajeros' },
	{ value: '4932#CNAE#H', label: 'Transporte por taxi' },
	{ value: '4939#CNAE#H', label: 'tipos de transporte terrestre de pasajeros n.c.o.p.' },
	{ value: '4941#CNAE#H', label: 'Transporte de mercancías por carretera' },
	{ value: '4942#CNAE#H', label: 'Servicios de mudanza' },
	{ value: '4950#CNAE#H', label: 'Transporte por tubería' },
	{ value: '5010#CNAE#H', label: 'Transporte marítimo de pasajeros' },
	{ value: '5020#CNAE#H', label: 'Transporte marítimo de mercancías' },
	{ value: '5030#CNAE#H', label: 'Transporte de pasajeros por vías navegables interiores' },
	{ value: '5040#CNAE#H', label: 'Transporte de mercancías por vías navegables interiores' },
	{ value: '5110#CNAE#H', label: 'Transporte aéreo de pasajeros' },
	{ value: '5121#CNAE#H', label: 'Transporte aéreo de mercancías' },
	{ value: '5122#CNAE#H', label: 'Transporte espacial' },
	{ value: '5210#CNAE#H', label: 'Depósito y almacenamiento' },
	{ value: '5221#CNAE#H', label: 'Actividades anexas al transporte terrestre' },
	{
		value: '5222#CNAE#H',
		label: 'Actividades anexas al transporte marítimo y por vías navegables interiores'
	},
	{ value: '5223#CNAE#H', label: 'Actividades anexas al transporte aéreo' },
	{ value: '5224#CNAE#H', label: 'Manipulación de mercancías' },
	{ value: '5229#CNAE#H', label: 'Otras actividades anexas al transporte' },
	{
		value: '5310#CNAE#H',
		label: 'Actividades postales sometidas a la obligación del servicio universal'
	},
	{ value: '5320#CNAE#H', label: 'Otras actividades postales y de correos' },
	{ value: '5510#CNAE#I', label: 'Hoteles y alojamientos similares' },
	{ value: '5520#CNAE#I', label: 'Alojamientos turísticos y otros alojamientos de corta estancia' },
	{ value: '5530#CNAE#I', label: 'Campings y aparcamientos para caravanas' },
	{ value: '5590#CNAE#I', label: 'Otros alojamientos' },
	{ value: '5610#CNAE#I', label: 'Restaurantes y puestos de comidas' },
	{ value: '5621#CNAE#I', label: 'Provisión de comidas preparadas para eventos' },
	{ value: '5629#CNAE#I', label: 'Otros servicios de comidas' },
	{ value: '5630#CNAE#I', label: 'Establecimientos de bebidas' },
	{ value: '5811#CNAE#J', label: 'Edición de libros' },
	{ value: '5812#CNAE#J', label: 'Edición de directorios y guías de direcciones postales' },
	{ value: '5813#CNAE#J', label: 'Edición de periódicos' },
	{ value: '5814#CNAE#J', label: 'Edición de revistas' },
	{ value: '5819#CNAE#J', label: 'Otras actividades editoriales' },
	{ value: '5821#CNAE#J', label: 'Edición de videojuegos' },
	{ value: '5829#CNAE#J', label: 'Edición de otros programas informáticos' },
	{
		value: '5912#CNAE#J',
		label: 'Actividades de postproducción cinematográfica, de vídeo y de programas de televisión'
	},
	{ value: '5914#CNAE#J', label: 'Actividades de exhibición cinematográfica' },
	{ value: '5915#CNAE#J', label: 'Actividades de producción cinematográfica y de vídeo' },
	{ value: '5916#CNAE#J', label: 'Actividades de producciones de programas de televisión' },
	{ value: '5917#CNAE#J', label: 'Actividades de distribución cinematográfica y de vídeo' },
	{ value: '5918#CNAE#J', label: 'Actividades de distribución de programas de televisión' },
	{ value: '5920#CNAE#J', label: 'Actividades de grabación de sonido y edición musical' },
	{ value: '6010#CNAE#J', label: 'Actividades de radiodifusión' },
	{ value: '6020#CNAE#J', label: 'Actividades de programación y emisión de televisión' },
	{ value: '6110#CNAE#J', label: 'Telecomunicaciones por cable' },
	{ value: '6120#CNAE#J', label: 'Telecomunicaciones inalámbricas' },
	{ value: '6130#CNAE#J', label: 'Telecomunicaciones por satélite' },
	{ value: '6190#CNAE#J', label: 'Otras actividades de telecomunicaciones' },
	{ value: '6201#CNAE#J', label: 'Actividades de programación informática' },
	{ value: '6202#CNAE#J', label: 'Actividades de consultoría informática' },
	{ value: '6203#CNAE#J', label: 'Gestión de recursos informáticos' },
	{
		value: '6209#CNAE#J',
		label: 'Otros servicios relacionados con las tecnologías de la información y la informática'
	},
	{ value: '6311#CNAE#J', label: 'Proceso de datos, hosting y actividades relacionadas' },
	{ value: '6312#CNAE#J', label: 'Portales web' },
	{ value: '6391#CNAE#J', label: 'Actividades de las agencias de noticias' },
	{ value: '6399#CNAE#J', label: 'Otros servicios de información n.c.o.p.' },
	{ value: '6411#CNAE#K', label: 'Banco central' },
	{ value: '6419#CNAE#K', label: 'Otra intermediación monetaria' },
	{ value: '6420#CNAE#K', label: 'Actividades de las sociedades holding' },
	{ value: '6430#CNAE#K', label: 'Inversión colectiva, fondos y entidades financieras similares' },
	{ value: '6491#CNAE#K', label: 'Arrendamiento financiero' },
	{ value: '6492#CNAE#K', label: 'Otras actividades crediticias' },
	{
		value: '6499#CNAE#K',
		label: 'Otros servicios financieros, excepto seguros y fondos de pensiones n.c.o.p.'
	},
	{ value: '6511#CNAE#K', label: 'Seguros de vida' },
	{ value: '6512#CNAE#K', label: 'Seguros distintos de los seguros de vida' },
	{ value: '6520#CNAE#K', label: 'Reaseguros' },
	{ value: '6530#CNAE#K', label: 'Fondos de pensiones' },
	{ value: '6611#CNAE#K', label: 'Administración de mercados financieros' },
	{
		value: '6612#CNAE#K',
		label: 'Actividades de intermediación en operaciones con valores y otros activos'
	},
	{
		value: '6619#CNAE#K',
		label:
			'Otras actividades auxiliares a los servicios financieros, excepto seguros y fondos de pensiones'
	},
	{ value: '6621#CNAE#K', label: 'Evaluación de riesgos y daños' },
	{ value: '6622#CNAE#K', label: 'Actividades de agentes y corredores de seguros' },
	{ value: '6629#CNAE#K', label: 'Otras actividades auxiliares a seguros y fondos de pensiones' },
	{ value: '6630#CNAE#K', label: 'Actividades de gestión de fondos' },
	{ value: '6810#CNAE#L', label: 'Compraventa de bienes inmobiliarios por cuenta propia' },
	{ value: '6820#CNAE#L', label: 'Alquiler de bienes inmobiliarios por cuenta propia' },
	{ value: '6831#CNAE#L', label: 'Agentes de la propiedad inmobiliaria' },
	{ value: '6832#CNAE#L', label: 'Gestión y administración de la propiedad inmobiliaria' },
	{ value: '6910#CNAE#M', label: 'Actividades jurídicas' },
	{
		value: '6920#CNAE#M',
		label: 'Actividades de contabilidad, teneduría de libros, auditoría y asesoría fiscal'
	},
	{ value: '7010#CNAE#M', label: 'Actividades de las sedes centrales' },
	{ value: '7021#CNAE#M', label: 'Relaciones públicas y comunicación' },
	{ value: '7022#CNAE#M', label: 'Otras actividades de consultoría de gestión empresarial' },
	{ value: '7111#CNAE#M', label: 'Servicios técnicos de arquitectura' },
	{
		value: '7112#CNAE#M',
		label:
			'Servicios técnicos de ingeniería y otras actividades relacionadas con el asesoramiento técnico'
	},
	{ value: '7120#CNAE#M', label: 'Ensayos y análisis técnicos' },
	{ value: '7211#CNAE#M', label: 'Investigación y desarrollo experimental en biotecnología' },
	{
		value: '7219#CNAE#M',
		label: 'Otra investigación y desarrollo experimental en ciencias naturales y técnicas'
	},
	{
		value: '7220#CNAE#M',
		label: 'Investigación y desarrollo experimental en ciencias sociales y humanidades'
	},
	{ value: '7311#CNAE#M', label: 'Agencias de publicidad' },
	{ value: '7312#CNAE#M', label: 'Servicios de representación de medios de comunicación' },
	{
		value: '7320#CNAE#M',
		label: 'Estudio de mercado y realización de encuestas de opinión pública'
	},
	{ value: '7410#CNAE#M', label: 'Actividades de diseño especializado' },
	{ value: '7420#CNAE#M', label: 'Actividades de fotografía' },
	{ value: '7430#CNAE#M', label: 'Actividades de traducción e interpretación' },
	{
		value: '7490#CNAE#M',
		label: 'Otras actividades profesionales, científicas y técnicas n.c.o.p.'
	},
	{ value: '7500#CNAE#M', label: 'Actividades veterinarias' },
	{ value: '7711#CNAE#N', label: 'Alquiler de automóviles y vehículos de motor ligeros' },
	{ value: '7712#CNAE#N', label: 'Alquiler de camiones' },
	{ value: '7721#CNAE#N', label: 'Alquiler de artículos de ocio y deportivos' },
	{ value: '7722#CNAE#N', label: 'Alquiler de cintas de vídeo y discos' },
	{
		value: '7729#CNAE#N',
		label: 'Alquiler de otros efectos personales y artículos de uso doméstico'
	},
	{ value: '7731#CNAE#N', label: 'Alquiler de maquinaria y equipo de uso agrícola' },
	{
		value: '7732#CNAE#N',
		label: 'Alquiler de maquinaria y equipo para la construcción e ingeniería civil'
	},
	{
		value: '7733#CNAE#N',
		label: 'Alquiler de maquinaria y equipo de oficina, incluidos ordenadores'
	},
	{ value: '7734#CNAE#N', label: 'Alquiler de medios de navegación' },
	{ value: '7735#CNAE#N', label: 'Alquiler de medios de transporte aéreo' },
	{
		value: '7739#CNAE#N',
		label: 'Alquiler de otra maquinaria, equipos y bienes tangibles n.c.o.p.'
	},
	{
		value: '7740#CNAE#N',
		label:
			'Arrendamiento de la propiedad intelectual y productos similares, excepto trabajos protegidos por los derechos de autor'
	},
	{ value: '7810#CNAE#N', label: 'Actividades de las agencias de colocación' },
	{ value: '7820#CNAE#N', label: 'Actividades de las empresas de trabajo temporal' },
	{ value: '7830#CNAE#N', label: 'Otra provisión de recursos humanos' },
	{ value: '7911#CNAE#N', label: 'Actividades de las agencias de viajes' },
	{ value: '7912#CNAE#N', label: 'Actividades de los operadores turísticos' },
	{
		value: '7990#CNAE#N',
		label: 'Otros servicios de reservas y actividades relacionadas con los mismos'
	},
	{ value: '8010#CNAE#N', label: 'Actividades de seguridad privada' },
	{ value: '8020#CNAE#N', label: 'Servicios de sistemas de seguridad' },
	{ value: '8030#CNAE#N', label: 'Actividades de investigación' },
	{ value: '8110#CNAE#N', label: 'Servicios integrales a edificios e instalaciones' },
	{ value: '8121#CNAE#N', label: 'Limpieza general de edificios' },
	{ value: '8122#CNAE#N', label: 'Otras actividades de limpieza industrial y de edificios' },
	{ value: '8129#CNAE#N', label: 'Otras actividades de limpieza' },
	{ value: '8130#CNAE#N', label: 'Actividades de jardinería' },
	{ value: '8211#CNAE#N', label: 'Servicios administrativos combinados' },
	{
		value: '8219#CNAE#N',
		label:
			'Actividades de fotocopiado, preparación de documentos y otras actividades especializadas de oficina'
	},
	{ value: '8220#CNAE#N', label: 'Actividades de los centros de llamadas' },
	{ value: '8230#CNAE#N', label: 'Organización de convenciones y ferias de muestras' },
	{
		value: '8291#CNAE#N',
		label: 'Actividades de las agencias de cobros y de información comercial'
	},
	{ value: '8292#CNAE#N', label: 'Actividades de envasado y empaquetado' },
	{ value: '8299#CNAE#N', label: 'Otras actividades de apoyo a las empresas n.c.o.p.' },
	{ value: '8411#CNAE#O', label: 'Actividades generales de la Administración Pública' },
	{
		value: '8412#CNAE#O',
		label:
			'Regulación de las actividades sanitarias, educativas y culturales y otros servicios sociales, excepto Seguridad Social'
	},
	{
		value: '8413#CNAE#O',
		label: 'Regulación de la actividad económica y contribución a su mayor eficiencia'
	},
	{ value: '8421#CNAE#O', label: 'Asuntos exteriores' },
	{ value: '8422#CNAE#O', label: 'Defensa' },
	{ value: '8423#CNAE#O', label: 'Justicia' },
	{ value: '8424#CNAE#O', label: 'Orden público y seguridad' },
	{ value: '8425#CNAE#O', label: 'Protección civil' },
	{ value: '8430#CNAE#O', label: 'Seguridad Social obligatoria' },
	{ value: '8510#CNAE#P', label: 'Educación preprimaria' },
	{ value: '8520#CNAE#P', label: 'Educación primaria' },
	{ value: '8531#CNAE#P', label: 'Educación secundaria general' },
	{ value: '8532#CNAE#P', label: 'Educación secundaria técnica y profesional' },
	{ value: '8541#CNAE#P', label: 'Educación postsecundaria no terciaria' },
	{ value: '8543#CNAE#P', label: 'Educación universitaria' },
	{ value: '8544#CNAE#P', label: 'Educación terciaria no universitaria' },
	{ value: '8551#CNAE#P', label: 'Educación deportiva y recreativa' },
	{ value: '8552#CNAE#P', label: 'Educación cultural' },
	{ value: '8553#CNAE#P', label: 'Actividades de las escuelas de conducción y pilotaje' },
	{ value: '8559#CNAE#P', label: 'Otra educación n.c.o.p.' },
	{ value: '8560#CNAE#P', label: 'Actividades auxiliares a la educación' },
	{ value: '8610#CNAE#Q', label: 'Actividades hospitalarias' },
	{ value: '8621#CNAE#Q', label: 'Actividades de medicina general' },
	{ value: '8622#CNAE#Q', label: 'Actividades de medicina especializada' },
	{ value: '8623#CNAE#Q', label: 'Actividades odontológicas' },
	{ value: '8690#CNAE#Q', label: 'Otras actividades sanitarias' },
	{
		value: '8710#CNAE#Q',
		label: 'Asistencia en establecimientos residenciales con cuidados sanitarios'
	},
	{
		value: '8720#CNAE#Q',
		label:
			'Asistencia en establecimientos residenciales para personas con discapacidad intelectual, enfermedad mental y drogodependencia'
	},
	{
		value: '8731#CNAE#Q',
		label: 'Asistencia en establecimientos residenciales para personas mayores'
	},
	{
		value: '8732#CNAE#Q',
		label: 'Asistencia en establecimientos residenciales para personas con discapacidad física'
	},
	{
		value: '8790#CNAE#Q',
		label: 'Otras actividades de asistencia en establecimientos residenciales'
	},
	{
		value: '8811#CNAE#Q',
		label: 'Actividades de servicios sociales sin alojamiento para personas mayores'
	},
	{
		value: '8812#CNAE#Q',
		label: 'Actividades de servicios sociales sin alojamiento para personas con discapacidad'
	},
	{ value: '8891#CNAE#Q', label: 'Actividades de cuidado diurno de niños' },
	{
		value: '8899#CNAE#Q',
		label: 'Otros actividades de servicios sociales sin alojamiento n.c.o.p.'
	},
	{ value: '9001#CNAE#R', label: 'Artes escénicas' },
	{ value: '9002#CNAE#R', label: 'Actividades auxiliares a las artes escénicas' },
	{ value: '9003#CNAE#R', label: 'Creación artística y literaria' },
	{ value: '9004#CNAE#R', label: 'Gestión de salas de espectáculos' },
	{ value: '9102#CNAE#R', label: 'Actividades de museos' },
	{ value: '9103#CNAE#R', label: 'Gestión de lugares y edificios históricos' },
	{
		value: '9104#CNAE#R',
		label: 'Actividades de los jardines botánicos, parques zoológicos y reservas naturales'
	},
	{ value: '9105#CNAE#R', label: 'Actividades de bibliotecas' },
	{ value: '9106#CNAE#R', label: 'Actividades de archivos' },
	{ value: '9200#CNAE#R', label: 'Actividades de juegos de azar y apuestas' },
	{ value: '9311#CNAE#R', label: 'Gestión de instalaciones deportivas' },
	{ value: '9312#CNAE#R', label: 'Actividades de los clubes deportivos' },
	{ value: '9313#CNAE#R', label: 'Actividades de los gimnasios' },
	{ value: '9319#CNAE#R', label: 'Otras actividades deportivas' },
	{
		value: '9321#CNAE#R',
		label: 'Actividades de los parques de atracciones y los parques temáticos'
	},
	{ value: '9329#CNAE#R', label: 'Otras actividades recreativas y de entretenimiento' },
	{ value: '9411#CNAE#S', label: 'Actividades de organizaciones empresariales y patronales' },
	{ value: '9412#CNAE#S', label: 'Actividades de organizaciones profesionales' },
	{ value: '9420#CNAE#S', label: 'Actividades sindicales' },
	{ value: '9491#CNAE#S', label: 'Actividades de organizaciones religiosas' },
	{ value: '9492#CNAE#S', label: 'Actividades de organizaciones políticas' },
	{ value: '9499#CNAE#S', label: 'Otras actividades asociativas n.c.o.p.' },
	{ value: '9511#CNAE#S', label: 'Reparación de ordenadores y equipos periféricos' },
	{ value: '9512#CNAE#S', label: 'Reparación de equipos de comunicación' },
	{
		value: '9521#CNAE#S',
		label: 'Reparación de aparatos electrónicos de audio y vídeo de uso doméstico'
	},
	{
		value: '9522#CNAE#S',
		label: 'Reparación de aparatos electrodomésticos y de equipos para el hogar y el jardín'
	},
	{ value: '9523#CNAE#S', label: 'Reparación de calzado y artículos de cuero' },
	{ value: '9524#CNAE#S', label: 'Reparación de muebles y artículos de menaje' },
	{ value: '9525#CNAE#S', label: 'Reparación de relojes y joyería' },
	{
		value: '9529#CNAE#S',
		label: 'Reparación de otros efectos personales y artículos de uso doméstico'
	},
	{ value: '9601#CNAE#S', label: 'Lavado y limpieza de prendas textiles y de piel' },
	{ value: '9602#CNAE#S', label: 'Peluquería y otros tratamientos de belleza' },
	{ value: '9603#CNAE#S', label: 'Pompas fúnebres y actividades relacionadas' },
	{ value: '9604#CNAE#S', label: 'Actividades de mantenimiento físico' },
	{ value: '9609#CNAE#S', label: 'Otras servicios personales n.c.o.p.' },
	{
		value: '9700#CNAE#T',
		label: 'Actividades de los hogares como empleadores de personal doméstico'
	},
	{
		value: '9810#CNAE#T',
		label: 'Actividades de los hogares como productores de bienes para uso propio'
	},
	{
		value: '9820#CNAE#T',
		label: 'Actividades de los hogares como productores de servicios para uso propio'
	},
	{ value: '9900#CNAE#U', label: 'Actividades de organizaciones y organismos extraterritoriales' },
	{
		value: '1111#CNO#A',
		label: 'Miembros del poder ejecutivo (nacional, autonómico y local) y del poder legislativo'
	},
	{ value: '1112#CNO#A', label: 'Personal directivo de la Administración Pública' },
	{ value: '1113#CNO#A', label: 'Directores de organizaciones de interés social' },
	{ value: '1120#CNO#A', label: 'Directores generales y presidentes ejecutivos' },
	{ value: '1211#CNO#A', label: 'Directores financieros' },
	{ value: '1212#CNO#A', label: 'Directores de recursos humanos' },
	{
		value: '1219#CNO#A',
		label:
			'Directores de políticas y planificación y de otros departamentos administrativos no clasificados bajo otros epígrafes'
	},
	{ value: '1221#CNO#A', label: 'Directores comerciales y de ventas' },
	{ value: '1222#CNO#A', label: 'Directores de publicidad y relaciones públicas' },
	{ value: '1223#CNO#A', label: 'Directores de investigación y desarrollo' },
	{
		value: '1311#CNO#A',
		label: 'Directores de producción de explotaciones agropecuarias y forestales'
	},
	{ value: '1312#CNO#A', label: 'Directores de producción de explotaciones pesqueras y acuícolas' },
	{ value: '1313#CNO#A', label: 'Directores de industrias manufactureras' },
	{ value: '1314#CNO#A', label: 'Directores de explotaciones mineras' },
	{
		value: '1315#CNO#A',
		label: 'Directores de empresas de abastecimiento, transporte, distribución y afines'
	},
	{ value: '1316#CNO#A', label: 'Directores de empresas de construcción' },
	{
		value: '1321#CNO#A',
		label: 'Directores de servicios de tecnologías de la información y las comunicaciones (TIC)'
	},
	{ value: '1322#CNO#A', label: 'Directores de servicios sociales para niños' },
	{ value: '1323#CNO#A', label: 'Directores-gerentes de centros sanitarios' },
	{ value: '1324#CNO#A', label: 'Directores de servicios sociales para personas mayores' },
	{ value: '1325#CNO#A', label: 'Directores de otros servicios sociales' },
	{ value: '1326#CNO#A', label: 'Directores de servicios de educación' },
	{
		value: '1327#CNO#A',
		label: 'Directores de sucursales de bancos, de servicios financieros y de seguros'
	},
	{
		value: '1329#CNO#A',
		label:
			'Directores de otras empresas de servicios profesionales no clasificados bajo otros epígrafes'
	},
	{ value: '1411#CNO#A', label: 'Directores y gerentes de hoteles' },
	{
		value: '1419#CNO#A',
		label: 'Directores y gerentes de otras empresas de servicios de alojamiento'
	},
	{ value: '1421#CNO#A', label: 'Directores y gerentes de restaurantes' },
	{ value: '1422#CNO#A', label: 'Directores y gerentes de bares, cafeterías y similares' },
	{
		value: '1429#CNO#A',
		label: 'Directores y gerentes de empresas de catering y otras empresas de restauración'
	},
	{ value: '1431#CNO#A', label: 'Directores y gerentes de empresas de comercio al por mayor' },
	{ value: '1432#CNO#A', label: 'Directores y gerentes de empresas de comercio al por menor' },
	{
		value: '1501#CNO#A',
		label: 'Directores y gerentes de empresas de actividades recreativas, culturales y deportivas'
	},
	{
		value: '1509#CNO#A',
		label:
			'Directores y gerentes de empresas de gestión de residuos y de otras empresas de servicios no clasificados bajo otros epígrafes'
	},
	{ value: '2111#CNO#B', label: 'Médicos de familia' },
	{ value: '2112#CNO#B', label: 'Otros médicos especialistas' },
	{ value: '2121#CNO#B', label: 'Enfermeros no especializados' },
	{ value: '2122#CNO#B', label: 'Enfermeros especializados (excepto matronos)' },
	{ value: '2123#CNO#B', label: 'Matronos' },
	{ value: '2130#CNO#B', label: 'Veterinarios' },
	{ value: '2140#CNO#B', label: 'Farmacéuticos' },
	{ value: '2151#CNO#B', label: 'Odontólogos y estomatólogos' },
	{ value: '2152#CNO#B', label: 'Fisioterapeutas' },
	{ value: '2153#CNO#B', label: 'Dietistas y nutricionistas' },
	{ value: '2154#CNO#B', label: 'Logopedas' },
	{ value: '2155#CNO#B', label: 'Ópticos-optometristas' },
	{ value: '2156#CNO#B', label: 'Terapeutas ocupacionales' },
	{ value: '2157#CNO#B', label: 'Podólogos' },
	{ value: '2158#CNO#B', label: 'Profesionales de la salud y la higiene laboral y ambiental' },
	{ value: '2159#CNO#B', label: 'Profesionales de la salud no clasificados bajo otros epígrafes' },
	{
		value: '2210#CNO#B',
		label: 'Profesores de universidades y otra enseñanza superior (excepto formación profesional)'
	},
	{ value: '2220#CNO#B', label: 'Profesores de formación profesional (materias específicas)' },
	{
		value: '2230#CNO#B',
		label:
			'Profesores de enseñanza secundaria (excepto materias específicas de formación profesional)'
	},
	{ value: '2240#CNO#B', label: 'Profesores de enseñanza primaria' },
	{ value: '2251#CNO#B', label: 'Maestros de educación infantil' },
	{ value: '2252#CNO#B', label: 'Técnicos en educación infantil' },
	{ value: '2311#CNO#B', label: 'Profesores de educación especial' },
	{ value: '2312#CNO#B', label: 'Técnicos educadores de educación especial' },
	{ value: '2321#CNO#B', label: 'Especialistas en métodos didácticos y pedagógicos' },
	{ value: '2322#CNO#B', label: 'Profesores de enseñanza no reglada de idiomas' },
	{ value: '2323#CNO#B', label: 'Profesores de enseñanza no reglada de música y danza' },
	{ value: '2324#CNO#B', label: 'Profesores de enseñanza no reglada de artes' },
	{
		value: '2325#CNO#B',
		label: 'Instructores en tecnologías de la información en enseñanza no reglada'
	},
	{ value: '2326#CNO#B', label: 'Profesionales de la educación ambiental' },
	{
		value: '2329#CNO#B',
		label: 'Profesores y profesionales de la enseñanza no clasificados bajo otros epígrafes'
	},
	{ value: '2411#CNO#C', label: 'Físicos y astrónomos' },
	{ value: '2412#CNO#C', label: 'Meteorólogos' },
	{ value: '2413#CNO#C', label: 'Químicos' },
	{ value: '2414#CNO#C', label: 'Geólogos y geofísicos' },
	{ value: '2415#CNO#C', label: 'Matemáticos y actuarios' },
	{ value: '2416#CNO#C', label: 'Estadísticos' },
	{ value: '2421#CNO#C', label: 'Biólogos, botánicos, zoólogos y afines' },
	{ value: '2422#CNO#C', label: 'Ingenieros agrónomos' },
	{ value: '2423#CNO#C', label: 'Ingenieros de montes' },
	{ value: '2424#CNO#C', label: 'Ingenieros técnicos agrícolas' },
	{ value: '2425#CNO#C', label: 'Ingenieros técnicos forestales y del medio natural' },
	{ value: '2426#CNO#C', label: 'Profesionales de la protección ambiental' },
	{ value: '2427#CNO#C', label: 'Enólogos' },
	{ value: '2431#CNO#C', label: 'Ingenieros industriales y de producción' },
	{ value: '2432#CNO#C', label: 'Ingenieros en construcción y obra civil' },
	{ value: '2433#CNO#C', label: 'Ingenieros mecánicos' },
	{ value: '2434#CNO#C', label: 'Ingenieros aeronáuticos' },
	{ value: '2435#CNO#C', label: 'Ingenieros químicos' },
	{ value: '2436#CNO#C', label: 'Ingenieros de minas, metalúrgicos y afines' },
	{ value: '2437#CNO#C', label: 'Ingenieros ambientales' },
	{ value: '2439#CNO#C', label: 'Ingenieros no clasificados bajo otros epígrafes' },
	{ value: '2441#CNO#C', label: 'Ingenieros en electricidad' },
	{ value: '2442#CNO#C', label: 'Ingenieros electrónicos' },
	{ value: '2443#CNO#C', label: 'Ingenieros en telecomunicaciones' },
	{ value: '2451#CNO#C', label: 'Arquitectos (excepto arquitectos paisajistas y urbanistas)' },
	{ value: '2452#CNO#C', label: 'Arquitectos paisajistas' },
	{ value: '2453#CNO#C', label: 'Urbanistas e ingenieros de tráfico' },
	{ value: '2454#CNO#C', label: 'Ingenieros geógrafos y cartógrafos' },
	{ value: '2461#CNO#C', label: 'Ingenieros técnicos industriales y de producción' },
	{ value: '2462#CNO#C', label: 'Ingenieros técnicos de obras públicas' },
	{ value: '2463#CNO#C', label: 'Ingenieros técnicos mecánicos' },
	{ value: '2464#CNO#C', label: 'Ingenieros técnicos aeronáuticos' },
	{ value: '2465#CNO#C', label: 'Ingenieros técnicos químicos' },
	{ value: '2466#CNO#C', label: 'Ingenieros técnicos de minas, metalúrgicos y afines' },
	{ value: '2469#CNO#C', label: 'Ingenieros técnicos no clasificados bajo otros epígrafes' },
	{ value: '2471#CNO#C', label: 'Ingenieros técnicos en electricidad' },
	{ value: '2472#CNO#C', label: 'Ingenieros técnicos en electrónica' },
	{ value: '2473#CNO#C', label: 'Ingenieros técnicos en telecomunicaciones' },
	{ value: '2481#CNO#C', label: 'Arquitectos técnicos y técnicos urbanistas' },
	{ value: '2482#CNO#C', label: 'Diseñadores de productos y de prendas' },
	{ value: '2483#CNO#C', label: 'Ingenieros técnicos en topografía' },
	{ value: '2484#CNO#C', label: 'Diseñadores gráficos y multimedia' },
	{ value: '2511#CNO#C', label: 'Abogados' },
	{ value: '2512#CNO#C', label: 'Fiscales' },
	{ value: '2513#CNO#C', label: 'Jueces y magistrados' },
	{ value: '2591#CNO#C', label: 'Notarios y registradores' },
	{ value: '2592#CNO#C', label: 'Procuradores' },
	{ value: '2599#CNO#C', label: 'Profesionales del derecho no clasificados bajo otros epígrafes' },
	{ value: '2611#CNO#C', label: 'Especialistas en contabilidad' },
	{ value: '2612#CNO#C', label: 'Asesores financieros y en inversiones' },
	{ value: '2613#CNO#C', label: 'Analistas financieros' },
	{ value: '2621#CNO#C', label: 'Analistas de gestión y organización' },
	{ value: '2622#CNO#C', label: 'Especialistas en administración de política de empresas' },
	{ value: '2623#CNO#C', label: 'Especialistas de la Administración Pública' },
	{ value: '2624#CNO#C', label: 'Especialistas en políticas y servicios de personal y afines' },
	{ value: '2625#CNO#C', label: 'Especialistas en formación de personal' },
	{ value: '2630#CNO#C', label: 'Técnicos de empresas y actividades turísticas' },
	{ value: '2640#CNO#C', label: 'Profesionales de ventas técnicas y médicas (excepto las TIC)' },
	{ value: '2651#CNO#C', label: 'Profesionales de la publicidad y la comercialización' },
	{ value: '2652#CNO#C', label: 'Profesionales de relaciones públicas' },
	{
		value: '2653#CNO#C',
		label: 'Profesionales de la venta de tecnologías de la información y las comunicaciones'
	},
	{ value: '2711#CNO#C', label: 'Analistas de sistemas' },
	{ value: '2712#CNO#C', label: 'Analistas y diseñadores de software' },
	{ value: '2713#CNO#C', label: 'Analistas, programadores y diseñadores Web y multimedia' },
	{
		value: '2719#CNO#C',
		label: 'Analistas y diseñadores de software y multimedia no clasificados bajo otros epígrafes'
	},
	{ value: '2721#CNO#C', label: 'Diseñadores y administradores de bases de datos' },
	{ value: '2722#CNO#C', label: 'Administradores de sistemas y redes' },
	{ value: '2723#CNO#C', label: 'Analistas de redes informáticas' },
	{
		value: '2729#CNO#C',
		label:
			'Especialistas en bases de datos y en redes informáticas no clasificados bajo otros epígrafes'
	},
	{ value: '2810#CNO#C', label: 'Economistas' },
	{ value: '2821#CNO#C', label: 'Sociólogos, geógrafos, antropólogos, arqueólogos y afines' },
	{ value: '2822#CNO#C', label: 'Filósofos, historiadores y profesionales en ciencias políticas' },
	{ value: '2823#CNO#C', label: 'Psicólogos' },
	{ value: '2824#CNO#C', label: 'Profesionales del trabajo y la educación social' },
	{ value: '2825#CNO#C', label: 'Agentes de igualdad de oportunidades entre mujeres y hombres' },
	{ value: '2830#CNO#C', label: 'Sacerdotes de las distintas religiones' },
	{ value: '2911#CNO#C', label: 'Archivistas y conservadores de museos' },
	{ value: '2912#CNO#C', label: 'Bibliotecarios, documentalistas y afines' },
	{ value: '2921#CNO#C', label: 'Escritores' },
	{ value: '2922#CNO#C', label: 'Periodistas' },
	{ value: '2923#CNO#C', label: 'Filólogos, intérpretes y traductores' },
	{ value: '2931#CNO#C', label: 'Artistas de artes plásticas y visuales' },
	{ value: '2932#CNO#C', label: 'Compositores, músicos y cantantes' },
	{ value: '2933#CNO#C', label: 'Coreógrafos y bailarines' },
	{ value: '2934#CNO#C', label: 'Directores de cine, de teatro y afines' },
	{ value: '2935#CNO#C', label: 'Actores' },
	{ value: '2936#CNO#C', label: 'Locutores de radio, televisión y otros presentadores' },
	{ value: '2937#CNO#C', label: 'Profesionales de espectáculos taurinos' },
	{
		value: '2939#CNO#C',
		label: 'Artistas creativos e interpretativos no clasificados bajo otros epígrafes'
	},
	{ value: '3110#CNO#D', label: 'Delineantes y dibujantes técnicos' },
	{ value: '3121#CNO#D', label: 'Técnicos en ciencias físicas y químicas' },
	{ value: '3122#CNO#D', label: 'Técnicos en construcción' },
	{ value: '3123#CNO#D', label: 'Técnicos en electricidad' },
	{ value: '3124#CNO#D', label: 'Técnicos en electrónica (excepto electromedicina)' },
	{ value: '3125#CNO#D', label: 'Técnicos en electrónica, especialidad en electromedicina' },
	{ value: '3126#CNO#D', label: 'Técnicos en mecánica' },
	{ value: '3127#CNO#D', label: 'Técnicos y analistas de laboratorio en química industrial' },
	{ value: '3128#CNO#D', label: 'Técnicos en metalurgia y minas' },
	{
		value: '3129#CNO#D',
		label: 'Otros técnicos de las ciencias físicas, químicas, medioambientales y de las ingenierías'
	},
	{ value: '3131#CNO#D', label: 'Técnicos en instalaciones de producción de energía' },
	{
		value: '3132#CNO#D',
		label:
			'Técnicos en instalaciones de tratamiento de residuos, de aguas y otros operadores en plantas similares'
	},
	{
		value: '3133#CNO#D',
		label: 'Técnicos en control de instalaciones de procesamiento de productos químicos'
	},
	{ value: '3134#CNO#D', label: 'Técnicos de refinerías de petróleo y gas natural' },
	{ value: '3135#CNO#D', label: 'Técnicos en control de procesos de producción de metales' },
	{
		value: '3139#CNO#D',
		label: 'Técnicos en control de procesos no clasificados bajo otros epígrafes'
	},
	{ value: '3141#CNO#D', label: 'Técnicos en ciencias biológicas (excepto en áreas sanitarias)' },
	{ value: '3142#CNO#D', label: 'Técnicos agropecuarios' },
	{ value: '3143#CNO#D', label: 'Técnicos forestales y del medio natural' },
	{ value: '3151#CNO#D', label: 'Jefes y oficiales de máquinas' },
	{ value: '3152#CNO#D', label: 'Capitanes y oficiales de puente' },
	{ value: '3153#CNO#D', label: 'Pilotos de aviación y profesionales afines' },
	{ value: '3154#CNO#D', label: 'Controladores de tráfico aéreo' },
	{ value: '3155#CNO#D', label: 'Técnicos en seguridad aeronáutica' },
	{
		value: '3160#CNO#D',
		label: 'Técnicos de control de calidad de las ciencias físicas, químicas y de las ingenierías'
	},
	{ value: '3201#CNO#D', label: 'Supervisores en ingeniería de minas' },
	{ value: '3202#CNO#D', label: 'Supervisores de la construcción' },
	{ value: '3203#CNO#D', label: 'Supervisores de industrias alimenticias y del tabaco' },
	{ value: '3204#CNO#D', label: 'Supervisores de industrias química y farmacéutica' },
	{
		value: '3205#CNO#D',
		label: 'Supervisores de industrias de transformación de plásticos, caucho y resinas naturales'
	},
	{ value: '3206#CNO#D', label: 'Supervisores de industrias de la madera y pastero papeleras' },
	{
		value: '3207#CNO#D',
		label:
			'Supervisores de la producción en industrias de artes gráficas y en la fabricación de productos de papel'
	},
	{ value: '3209#CNO#D', label: 'Supervisores de otras industrias manufactureras' },
	{ value: '3311#CNO#D', label: 'Técnicos en radioterapia' },
	{ value: '3312#CNO#D', label: 'Técnicos en imagen para el diagnóstico' },
	{ value: '3313#CNO#D', label: 'Técnicos en anatomía patológica y citología' },
	{ value: '3314#CNO#D', label: 'Técnicos en laboratorio de diagnóstico clínico' },
	{ value: '3315#CNO#D', label: 'Técnicos en ortoprótesis' },
	{ value: '3316#CNO#D', label: 'Técnicos en prótesis dentales' },
	{ value: '3317#CNO#D', label: 'Técnicos en audioprótesis' },
	{ value: '3321#CNO#D', label: 'Técnicos superiores en higiene bucodental' },
	{ value: '3322#CNO#D', label: 'Técnicos superiores en documentación sanitaria' },
	{ value: '3323#CNO#D', label: 'Técnicos superiores en dietética' },
	{ value: '3324#CNO#D', label: 'Técnicos en optometría' },
	{ value: '3325#CNO#D', label: 'Ayudantes fisioterapeutas' },
	{ value: '3326#CNO#D', label: 'Técnicos en prevención de riesgos laborales y salud ambiental' },
	{ value: '3327#CNO#D', label: 'Ayudantes de veterinaria' },
	{ value: '3329#CNO#D', label: 'Técnicos de la sanidad no clasificados bajo otros epígrafes' },
	{
		value: '3331#CNO#D',
		label:
			'Profesionales de la acupuntura, la naturopatía, la homeopatía, la medicina tradicional china y la ayurveda'
	},
	{ value: '3339#CNO#D', label: 'Otros profesionales de las terapias alternativas' },
	{
		value: '3401#CNO#D',
		label: 'Profesionales de apoyo e intermediarios de cambio, bolsa y finanzas'
	},
	{ value: '3402#CNO#D', label: 'Comerciales de préstamos y créditos' },
	{ value: '3403#CNO#D', label: 'Tenedores de libros' },
	{
		value: '3404#CNO#D',
		label: 'Profesionales de apoyo en servicios estadísticos, matemáticos y afines'
	},
	{ value: '3405#CNO#D', label: 'Tasadores' },
	{ value: '3510#CNO#D', label: 'Agentes y representantes comerciales' },
	{ value: '3521#CNO#D', label: 'Mediadores y agentes de seguros' },
	{ value: '3522#CNO#D', label: 'Agentes de compras' },
	{ value: '3523#CNO#D', label: 'Consignatarios' },
	{ value: '3531#CNO#D', label: 'Representantes de aduanas' },
	{ value: '3532#CNO#D', label: 'Organizadores de conferencias y eventos' },
	{
		value: '3533#CNO#D',
		label:
			'Agentes o intermediarios en la contratación de la mano de obra (excepto representantes de espectáculos)'
	},
	{ value: '3534#CNO#D', label: 'Agentes y administradores de la propiedad inmobiliaria' },
	{ value: '3535#CNO#D', label: 'Portavoces y agentes de relaciones públicas' },
	{
		value: '3539#CNO#D',
		label:
			'Representantes artísticos y deportivos y otros agentes de servicios comerciales no clasificados bajo otros epígrafes'
	},
	{ value: '3611#CNO#D', label: 'Supervisores de secretaría' },
	{ value: '3612#CNO#D', label: 'Asistentes jurídico-legales' },
	{ value: '3613#CNO#D', label: 'Asistentes de dirección y administrativos' },
	{ value: '3614#CNO#D', label: 'Secretarios de centros médicos o clínicas' },
	{ value: '3621#CNO#D', label: 'Profesionales de apoyo de la Administración Pública de tributos' },
	{
		value: '3622#CNO#D',
		label: 'Profesionales de apoyo de la Administración Pública de servicios sociales'
	},
	{
		value: '3623#CNO#D',
		label:
			'Profesionales de apoyo de la Administración Pública de servicios de expedición de licencias'
	},
	{
		value: '3629#CNO#D',
		label:
			'Otros profesionales de apoyo de la Administración Pública para tareas de inspección y control y tareas similares'
	},
	{ value: '3631#CNO#D', label: 'Técnicos de la policía nacional, autonómica y local' },
	{ value: '3632#CNO#D', label: 'Suboficiales de la guardia civil' },
	{
		value: '3711#CNO#D',
		label: 'Profesionales de apoyo de servicios jurídicos y servicios similares'
	},
	{ value: '3712#CNO#D', label: 'Detectives privados' },
	{ value: '3713#CNO#D', label: 'Profesionales de apoyo al trabajo y a la educación social' },
	{ value: '3714#CNO#D', label: 'Promotores de igualdad de oportunidades entre mujeres y hombres' },
	{ value: '3715#CNO#D', label: 'Animadores comunitarios' },
	{ value: '3716#CNO#D', label: 'Auxiliares laicos de las religiones' },
	{ value: '3721#CNO#D', label: 'Atletas y deportistas' },
	{ value: '3722#CNO#D', label: 'Entrenadores y árbitros de actividades deportivas' },
	{ value: '3723#CNO#D', label: 'Instructores de actividades deportivas' },
	{ value: '3724#CNO#D', label: 'Monitores de actividades recreativas y de entretenimiento' },
	{ value: '3731#CNO#D', label: 'Fotógrafos' },
	{ value: '3732#CNO#D', label: 'Diseñadores y decoradores de interior' },
	{ value: '3733#CNO#D', label: 'Técnicos en galerías de arte, museos y bibliotecas' },
	{ value: '3734#CNO#D', label: 'Chefs' },
	{
		value: '3739#CNO#D',
		label: 'Otros técnicos y profesionales de apoyo de actividades culturales y artísticas'
	},
	{ value: '3811#CNO#D', label: 'Técnicos en operaciones de sistemas informáticos' },
	{
		value: '3812#CNO#D',
		label: 'Técnicos en asistencia al usuario de tecnologías de la información'
	},
	{ value: '3813#CNO#D', label: 'Técnicos en redes' },
	{ value: '3814#CNO#D', label: 'Técnicos de la Web' },
	{ value: '3820#CNO#D', label: 'Programadores informáticos' },
	{ value: '3831#CNO#D', label: 'Técnicos de grabación audiovisual' },
	{ value: '3832#CNO#D', label: 'Técnicos de radiodifusión' },
	{ value: '3833#CNO#D', label: 'Técnicos de ingeniería de las telecomunicaciones' },
	{ value: '4111#CNO#E', label: 'Empleados de contabilidad' },
	{ value: '4112#CNO#E', label: 'Empleados de control de personal y nóminas' },
	{
		value: '4113#CNO#E',
		label: 'Empleados de oficina de servicios estadísticos, financieros y bancarios'
	},
	{ value: '4121#CNO#E', label: 'Empleados de control de abastecimientos e inventario' },
	{ value: '4122#CNO#E', label: 'Empleados de oficina de servicios de apoyo a la producción' },
	{ value: '4123#CNO#E', label: 'Empleados de logística y transporte de pasajeros y mercancías' },
	{ value: '4210#CNO#E', label: 'Empleados de bibliotecas y archivos' },
	{
		value: '4221#CNO#E',
		label: 'Empleados de servicios de correos (excepto empleados de mostrador)'
	},
	{ value: '4222#CNO#E', label: 'Codificadores y correctores de imprenta' },
	{ value: '4223#CNO#E', label: 'Empleados de servicio de personal' },
	{ value: '4301#CNO#E', label: 'Grabadores de datos' },
	{
		value: '4309#CNO#E',
		label:
			'Empleados administrativos sin tareas de atención al público no clasificados bajo otros epígrafes'
	},
	{ value: '4411#CNO#F', label: 'Empleados de información al usuario' },
	{ value: '4412#CNO#F', label: 'Recepcionistas (excepto de hoteles)' },
	{ value: '4421#CNO#F', label: 'Empleados de agencias de viajes' },
	{ value: '4422#CNO#F', label: 'Recepcionistas de hoteles' },
	{ value: '4423#CNO#F', label: 'Telefonistas' },
	{ value: '4424#CNO#F', label: 'Teleoperadores' },
	{ value: '4430#CNO#F', label: 'Agentes de encuestas' },
	{ value: '4441#CNO#F', label: 'Cajeros de bancos y afines' },
	{ value: '4442#CNO#F', label: 'Empleados de venta de apuestas' },
	{ value: '4443#CNO#F', label: 'Empleados de sala de juegos y afines' },
	{ value: '4444#CNO#F', label: 'Empleados de casas de empeño y de préstamos' },
	{ value: '4445#CNO#F', label: 'Cobradores de facturas, deudas y empleados afines' },
	{ value: '4446#CNO#F', label: 'Empleados de mostrador de correos' },
	{
		value: '4500#CNO#F',
		label:
			'Empleados administrativos con tareas de atención al público no clasificados bajo otros epígrafes'
	},
	{ value: '5000#CNO#G', label: 'Camareros y cocineros propietarios' },
	{ value: '5110#CNO#G', label: 'Cocineros asalariados' },
	{ value: '5120#CNO#G', label: 'Camareros asalariados' },
	{ value: '5210#CNO#G', label: 'Jefes de sección de tiendas y almacenes' },
	{ value: '5220#CNO#G', label: 'Vendedores en tiendas y almacenes' },
	{ value: '5300#CNO#G', label: 'Comerciantes propietarios de tiendas' },
	{ value: '5411#CNO#G', label: 'Vendedores en quioscos' },
	{ value: '5412#CNO#G', label: 'Vendedores en mercados ocasionales y mercadillos' },
	{ value: '5420#CNO#G', label: 'Operadores de telemarketing' },
	{ value: '5430#CNO#G', label: 'Expendedores de gasolineras' },
	{ value: '5491#CNO#G', label: 'Vendedores a domicilio' },
	{ value: '5492#CNO#G', label: 'Promotores de venta' },
	{ value: '5493#CNO#G', label: 'Modelos de moda, arte y publicidad' },
	{ value: '5499#CNO#G', label: 'Vendedores no clasificados bajo otros epígrafes' },
	{ value: '5500#CNO#G', label: 'Cajeros y taquilleros (excepto bancos)' },
	{ value: '5611#CNO#H', label: 'Auxiliares de enfermería hospitalaria' },
	{ value: '5612#CNO#H', label: 'Auxiliares de enfermería de atención primaria' },
	{ value: '5621#CNO#H', label: 'Técnicos auxiliares de farmacia' },
	{ value: '5622#CNO#H', label: 'Técnicos de emergencias sanitarias' },
	{
		value: '5629#CNO#H',
		label:
			'Trabajadores de los cuidados a las personas en servicios de salud no clasificados bajo otros epígrafes'
	},
	{ value: '5710#CNO#H', label: 'Trabajadores de los cuidados personales a domicilio' },
	{ value: '5721#CNO#H', label: 'Cuidadores de niños en guarderías y centros educativos' },
	{ value: '5722#CNO#H', label: 'Cuidadores de niños en domicilios' },
	{ value: '5811#CNO#H', label: 'Peluqueros' },
	{ value: '5812#CNO#H', label: 'Especialistas en tratamientos de estética, bienestar y afines' },
	{ value: '5821#CNO#H', label: 'Auxiliares de vuelo y camareros de avión, barco y tren' },
	{ value: '5822#CNO#H', label: 'Revisores y cobradores de transporte terrestre' },
	{ value: '5823#CNO#H', label: 'Acompañantes turísticos' },
	{ value: '5824#CNO#H', label: 'Azafatos de tierra' },
	{ value: '5825#CNO#H', label: 'Guías de turismo' },
	{
		value: '5831#CNO#H',
		label: 'Supervisores de mantenimiento y limpieza en oficinas, hoteles y otros establecimientos'
	},
	{ value: '5832#CNO#H', label: 'Mayordomos del servicio doméstico' },
	{ value: '5833#CNO#H', label: 'Conserjes de edificios' },
	{ value: '5840#CNO#H', label: 'Trabajadores propietarios de pequeños alojamientos' },
	{ value: '5891#CNO#H', label: 'Asistentes personales o personas de compañía' },
	{ value: '5892#CNO#H', label: 'Empleados de pompas fúnebres y embalsamadores' },
	{ value: '5893#CNO#H', label: 'Cuidadores de animales y adiestradores' },
	{ value: '5894#CNO#H', label: 'Instructores de autoescuela' },
	{ value: '5895#CNO#H', label: 'Astrólogos, adivinadores y afines' },
	{
		value: '5899#CNO#H',
		label: 'Trabajadores de servicios personales no clasificados bajo otros epígrafes'
	},
	{ value: '5910#CNO#I', label: 'Guardias civiles' },
	{ value: '5921#CNO#I', label: 'Policías nacionales' },
	{ value: '5922#CNO#I', label: 'Policías autonómicos' },
	{ value: '5923#CNO#I', label: 'Policías locales' },
	{ value: '5931#CNO#I', label: 'Bomberos (excepto forestales)' },
	{ value: '5932#CNO#I', label: 'Bomberos forestales' },
	{ value: '5941#CNO#I', label: 'Vigilantes de seguridad y similares habilitados para ir armados' },
	{
		value: '5942#CNO#I',
		label: 'Auxiliares de vigilante de seguridad y similares no habilitados para ir armados'
	},
	{ value: '5991#CNO#I', label: 'Vigilantes de prisiones' },
	{ value: '5992#CNO#I', label: 'Bañistas-socorristas' },
	{ value: '5993#CNO#I', label: 'Agentes forestales y medioambientales' },
	{
		value: '5999#CNO#I',
		label:
			'Trabajadores de los servicios de protección y seguridad no clasificados bajo otros epígrafes'
	},
	{
		value: '6110#CNO#J',
		label:
			'Trabajadores cualificados en actividades agrícolas (excepto en huertas, invernaderos, viveros y jardines)'
	},
	{
		value: '6120#CNO#J',
		label: 'Trabajadores cualificados en huertas, invernaderos, viveros y jardines'
	},
	{ value: '6201#CNO#J', label: 'Trabajadores cualificados en actividades ganaderas de vacuno' },
	{
		value: '6202#CNO#J',
		label: 'Trabajadores cualificados en actividades ganaderas de ovino y caprino'
	},
	{ value: '6203#CNO#J', label: 'Trabajadores cualificados en actividades ganaderas de porcino' },
	{ value: '6204#CNO#J', label: 'Trabajadores cualificados en apicultura y sericicultura' },
	{ value: '6205#CNO#J', label: 'Trabajadores cualificados en la avicultura y la cunicultura' },
	{
		value: '6209#CNO#J',
		label: 'Trabajadores cualificados en actividades ganaderas no clasificados bajo otros epígrafes'
	},
	{ value: '6300#CNO#J', label: 'Trabajadores cualificados en actividades agropecuarias mixtas' },
	{
		value: '6410#CNO#J',
		label: 'Trabajadores cualificados en actividades forestales y del medio natural'
	},
	{ value: '6421#CNO#J', label: 'Trabajadores cualificados en la acuicultura' },
	{ value: '6422#CNO#J', label: 'Pescadores de aguas costeras y aguas dulces' },
	{ value: '6423#CNO#J', label: 'Pescadores de altura' },
	{ value: '6430#CNO#J', label: 'Trabajadores cualificados en actividades cinegéticas' },
	{ value: '7111#CNO#K', label: 'Encofradores y operarios de puesta en obra de hormigón' },
	{ value: '7112#CNO#K', label: 'Montadores de prefabricados estructurales (sólo hormigón)' },
	{ value: '7121#CNO#K', label: 'Albañiles' },
	{ value: '7122#CNO#K', label: 'Canteros, tronzadores, labrantes y grabadores de piedras' },
	{ value: '7131#CNO#K', label: 'Carpinteros (excepto ebanistas)' },
	{
		value: '7132#CNO#K',
		label:
			'Instaladores de cerramientos metálicos y carpinteros metálicos (excepto montadores de estructuras metálicas)'
	},
	{ value: '7191#CNO#K', label: 'Mantenedores de edificios' },
	{ value: '7192#CNO#K', label: 'Instaladores de fachadas técnicas' },
	{ value: '7193#CNO#K', label: 'Instaladores de sistemas de impermeabilización en edificios' },
	{
		value: '7199#CNO#K',
		label:
			'Otros trabajadores de las obras estructurales de construcción no clasificados bajo otros epígrafes'
	},
	{ value: '7211#CNO#K', label: 'Escayolistas' },
	{ value: '7212#CNO#K', label: 'Aplicadores de revestimientos de pasta y mortero' },
	{ value: '7221#CNO#K', label: 'Fontaneros' },
	{ value: '7222#CNO#K', label: 'Montadores-instaladores de gas en edificios' },
	{ value: '7223#CNO#K', label: 'Instaladores de conductos en obra pública' },
	{ value: '7231#CNO#K', label: 'Pintores y empapeladores' },
	{ value: '7232#CNO#K', label: 'Pintores en las industrias manufactureras' },
	{ value: '7240#CNO#K', label: 'Soladores, colocadores de parquet y afines' },
	{ value: '7250#CNO#K', label: 'Mecánicos-instaladores de refrigeración y climatización' },
	{ value: '7291#CNO#K', label: 'Montadores de cubiertas' },
	{ value: '7292#CNO#K', label: 'Instaladores de material aislante térmico y de insonorización' },
	{ value: '7293#CNO#K', label: 'Cristaleros' },
	{ value: '7294#CNO#K', label: 'Montadores-instaladores de placas de energía solar' },
	{ value: '7295#CNO#K', label: 'Personal de limpieza de fachadas de edificios y chimeneas' },
	{ value: '7311#CNO#L', label: 'Moldeadores y macheros' },
	{ value: '7312#CNO#L', label: 'Soldadores y oxicortadores' },
	{ value: '7313#CNO#L', label: 'Chapistas y caldereros' },
	{ value: '7314#CNO#L', label: 'Montadores de estructuras metálicas' },
	{ value: '7315#CNO#L', label: 'Montadores de estructuras cableadas y empalmadores de cables' },
	{ value: '7321#CNO#L', label: 'Herreros y forjadores' },
	{
		value: '7322#CNO#L',
		label:
			'Trabajadores de la fabricación de herramientas, mecánico-ajustadores, modelistas, matriceros y afines'
	},
	{ value: '7323#CNO#L', label: 'Ajustadores y operadores de máquinas-herramienta' },
	{ value: '7324#CNO#L', label: 'Pulidores de metales y afiladores de herramientas' },
	{ value: '7401#CNO#L', label: 'Mecánicos y ajustadores de vehículos de motor' },
	{ value: '7402#CNO#L', label: 'Mecánicos y ajustadores de motores de avión' },
	{ value: '7403#CNO#L', label: 'Mecánicos y ajustadores de maquinaria agrícola e industrial' },
	{ value: '7404#CNO#L', label: 'Mecánicos y ajustadores de maquinaria naval y ferroviaria' },
	{ value: '7405#CNO#L', label: 'Reparadores de bicicletas y afines' },
	{ value: '7510#CNO#L', label: 'Electricistas de la construcción y afines' },
	{ value: '7521#CNO#L', label: 'Mecánicos y reparadores de equipos eléctricos' },
	{ value: '7522#CNO#L', label: 'Instaladores y reparadores de líneas eléctricas' },
	{ value: '7531#CNO#L', label: 'Mecánicos y reparadores de equipos electrónicos' },
	{ value: '7532#CNO#L', label: 'Instaladores y reparadores en electromedicina' },
	{
		value: '7533#CNO#L',
		label: 'Instaladores y reparadores en tecnologías de la información y las comunicaciones'
	},
	{ value: '7611#CNO#L', label: 'Relojeros y mecánicos de instrumentos de precisión' },
	{ value: '7612#CNO#L', label: 'Lutieres y similares; afinadores de instrumentos musicales' },
	{ value: '7613#CNO#L', label: 'Joyeros, orfebres y plateros' },
	{ value: '7614#CNO#L', label: 'Trabajadores de la cerámica, alfareros y afines' },
	{
		value: '7615#CNO#L',
		label: 'Sopladores, modeladores, laminadores, cortadores y pulidores de vidrio'
	},
	{
		value: '7616#CNO#L',
		label: 'Rotulistas, grabadores de vidrio, pintores decorativos de artículos diversos'
	},
	{
		value: '7617#CNO#L',
		label: 'Artesanos en madera y materiales similares; cesteros, bruceros y trabajadores afines'
	},
	{
		value: '7618#CNO#L',
		label:
			'Artesanos en tejidos, cueros y materiales similares, preparadores de fibra y tejedores con telares artesanos o de tejidos de punto y afines'
	},
	{ value: '7619#CNO#L', label: 'Artesanos no clasificados bajo otros epígrafes' },
	{ value: '7621#CNO#L', label: 'Trabajadores de procesos de preimpresión' },
	{ value: '7622#CNO#L', label: 'Trabajadores de procesos de impresión' },
	{ value: '7623#CNO#L', label: 'Trabajadores de procesos de encuadernación' },
	{ value: '7701#CNO#L', label: 'Matarifes y trabajadores de las industrias cárnicas' },
	{ value: '7702#CNO#L', label: 'Trabajadores de las industrias del pescado' },
	{ value: '7703#CNO#L', label: 'Panaderos, pasteleros y confiteros' },
	{
		value: '7704#CNO#L',
		label:
			'Trabajadores del tratamiento de la leche y elaboración de productos lácteos (incluidos helados)'
	},
	{
		value: '7705#CNO#L',
		label:
			'Trabajadores conserveros de frutas y hortalizas y trabajadores de la elaboración de bebidas no alcohólicas'
	},
	{
		value: '7706#CNO#L',
		label: 'Trabajadores de la elaboración de bebidas alcohólicas distintas del vino'
	},
	{ value: '7707#CNO#L', label: 'Trabajadores de la elaboración del vino' },
	{ value: '7708#CNO#L', label: 'Preparadores y elaboradores del tabaco y sus productos' },
	{ value: '7709#CNO#L', label: 'Catadores y clasificadores de alimentos y bebidas' },
	{ value: '7811#CNO#L', label: 'Trabajadores del tratamiento de la madera' },
	{ value: '7812#CNO#L', label: 'Ajustadores y operadores de máquinas para trabajar la madera' },
	{ value: '7820#CNO#L', label: 'Ebanistas y trabajadores afines' },
	{ value: '7831#CNO#L', label: 'Sastres, modistos, peleteros y sombrereros' },
	{ value: '7832#CNO#L', label: 'Patronistas para productos en textil y piel' },
	{ value: '7833#CNO#L', label: 'Cortadores de tejidos, cuero, piel y otros materiales' },
	{ value: '7834#CNO#L', label: 'Costureros a mano, bordadores y afines' },
	{ value: '7835#CNO#L', label: 'Tapiceros, colchoneros y afines' },
	{ value: '7836#CNO#L', label: 'Curtidores y preparadores de pieles' },
	{ value: '7837#CNO#L', label: 'Zapateros y afines' },
	{ value: '7891#CNO#L', label: 'Buceadores' },
	{ value: '7892#CNO#L', label: 'Pegadores' },
	{
		value: '7893#CNO#L',
		label: 'Clasificadores y probadores de productos (excepto alimentos, bebidas y tabaco)'
	},
	{ value: '7894#CNO#L', label: 'Fumigadores y otros controladores de plagas y malas hierbas' },
	{
		value: '7899#CNO#L',
		label: 'Oficiales, operarios y artesanos de otros oficios no clasificados bajo otros epígrafes'
	},
	{ value: '8111#CNO#M', label: 'Mineros y otros operadores en instalaciones mineras' },
	{
		value: '8112#CNO#M',
		label: 'Operadores en instalaciones para la preparación de minerales y rocas'
	},
	{ value: '8113#CNO#M', label: 'Sondistas y trabajadores afines' },
	{
		value: '8114#CNO#M',
		label: 'Operadores de maquinaria para fabricar productos derivados de minerales no metálicos'
	},
	{
		value: '8121#CNO#M',
		label: 'Operadores en instalaciones para la obtención y transformación de metales'
	},
	{
		value: '8122#CNO#M',
		label: 'Operadores de máquinas pulidoras, galvanizadoras y recubridoras de metales'
	},
	{ value: '8131#CNO#M', label: 'Operadores en plantas industriales químicas' },
	{
		value: '8132#CNO#M',
		label: 'Operadores de máquinas para fabricar productos farmacéuticos, cosméticos y afines'
	},
	{ value: '8133#CNO#M', label: 'Operadores de laboratorios fotográficos y afines' },
	{
		value: '8141#CNO#M',
		label:
			'Operadores de máquinas para fabricar productos de caucho y derivados de resinas naturales'
	},
	{
		value: '8142#CNO#M',
		label: 'Operadores de máquinas para fabricar productos de material plástico'
	},
	{
		value: '8143#CNO#M',
		label: 'Operadores de máquinas para fabricar productos de papel y cartón'
	},
	{
		value: '8144#CNO#M',
		label:
			'Operadores de serrerías, de máquinas de fabricación de tableros y de instalaciones afines para el tratamiento de la madera y el corcho'
	},
	{
		value: '8145#CNO#M',
		label:
			'Operadores en instalaciones para la preparación de pasta de papel y fabricación de papel'
	},
	{ value: '8151#CNO#M', label: 'Operadores de máquinas para preparar fibras, hilar y devanar' },
	{ value: '8152#CNO#M', label: 'Operadores de telares y otras máquinas tejedoras' },
	{ value: '8153#CNO#M', label: 'Operadores de máquinas de coser y bordar' },
	{
		value: '8154#CNO#M',
		label: 'Operadores de máquinas de blanquear, teñir, estampar y acabar textiles'
	},
	{ value: '8155#CNO#M', label: 'Operadores de máquinas para tratar pieles y cuero' },
	{
		value: '8156#CNO#M',
		label:
			'Operadores de máquinas para la fabricación del calzado, marroquinería y guantería de piel'
	},
	{
		value: '8159#CNO#M',
		label:
			'Operadores de máquinas para fabricar productos textiles no clasificados bajo otros epígrafes'
	},
	{
		value: '8160#CNO#M',
		label: 'Operadores de máquinas para elaborar productos alimenticios, bebidas y tabaco'
	},
	{ value: '8170#CNO#M', label: 'Operadores de máquinas de lavandería y tintorería' },
	{ value: '8191#CNO#M', label: 'Operadores de hornos e instalaciones de vidriería y cerámica' },
	{ value: '8192#CNO#M', label: 'Operadores de calderas y máquinas de vapor' },
	{
		value: '8193#CNO#M',
		label: 'Operadores de máquinas de embalaje, embotellamiento y etiquetado'
	},
	{
		value: '8199#CNO#M',
		label: 'Operadores de instalaciones y maquinaria fijas no clasificados bajo otros epígrafes'
	},
	{ value: '8201#CNO#M', label: 'Ensambladores de maquinaria mecánica' },
	{ value: '8202#CNO#M', label: 'Ensambladores de equipos eléctricos y electrónicos' },
	{ value: '8209#CNO#M', label: 'Montadores y ensambladores no clasificados en otros epígrafes' },
	{ value: '8311#CNO#N', label: 'Maquinistas de locomotoras' },
	{ value: '8312#CNO#N', label: 'Agentes de maniobras ferroviarias' },
	{ value: '8321#CNO#N', label: 'Operadores de maquinaria agrícola móvil' },
	{ value: '8322#CNO#N', label: 'Operadores de maquinaria forestal móvil' },
	{
		value: '8331#CNO#N',
		label: 'Operadores de maquinaria de movimientos de tierras y equipos similares'
	},
	{
		value: '8332#CNO#N',
		label: 'Operadores de grúas, montacargas y de maquinaria similar de movimiento de materiales'
	},
	{ value: '8333#CNO#N', label: 'Operadores de carretillas elevadoras' },
	{ value: '8340#CNO#N', label: 'Marineros de puente, marineros de máquinas y afines' },
	{ value: '8411#CNO#N', label: 'Conductores propietarios de automóviles, taxis y furgonetas' },
	{ value: '8412#CNO#N', label: 'Conductores asalariados de automóviles, taxis y furgonetas' },
	{ value: '8420#CNO#N', label: 'Conductores de autobuses y tranvías' },
	{ value: '8431#CNO#N', label: 'Conductores propietarios de camiones' },
	{ value: '8432#CNO#N', label: 'Conductores asalariados de camiones' },
	{ value: '8440#CNO#N', label: 'Conductores de motocicletas y ciclomotores' },
	{ value: '9100#CNO#O', label: 'Empleados domésticos' },
	{
		value: '9210#CNO#O',
		label: 'Personal de limpieza de oficinas, hoteles y otros establecimientos similares'
	},
	{ value: '9221#CNO#O', label: 'Limpiadores en seco a mano y afines' },
	{ value: '9222#CNO#O', label: 'Limpiadores de vehículos' },
	{ value: '9223#CNO#O', label: 'Limpiadores de ventanas' },
	{ value: '9229#CNO#O', label: 'Otro personal de limpieza' },
	{ value: '9310#CNO#O', label: 'Ayudantes de cocina' },
	{ value: '9320#CNO#O', label: 'Preparadores de comidas rápidas' },
	{ value: '9410#CNO#O', label: 'Vendedores callejeros' },
	{
		value: '9420#CNO#O',
		label: 'Repartidores de publicidad, limpiabotas y otros trabajadores de oficios callejeros'
	},
	{ value: '9431#CNO#O', label: 'Ordenanzas' },
	{ value: '9432#CNO#O', label: 'Mozos de equipaje y afines' },
	{ value: '9433#CNO#O', label: 'Repartidores, recadistas y mensajeros a pie' },
	{
		value: '9434#CNO#O',
		label: 'Lectores de contadores y recaudadores de máquinas recreativas y expendedoras'
	},
	{ value: '9441#CNO#O', label: 'Recogedores de residuos' },
	{
		value: '9442#CNO#O',
		label: 'Clasificadores de desechos, operarios de punto limpio y recogedores de chatarra'
	},
	{ value: '9443#CNO#O', label: 'Barrenderos y afines' },
	{ value: '9490#CNO#O', label: 'Otras ocupaciones elementales' },
	{
		value: '9511#CNO#P',
		label: 'Peones agrícolas (excepto en huertas, invernaderos, viveros y jardines)'
	},
	{ value: '9512#CNO#P', label: 'Peones agrícolas en huertas, invernaderos, viveros y jardines' },
	{ value: '9520#CNO#P', label: 'Peones ganaderos' },
	{ value: '9530#CNO#P', label: 'Peones agropecuarios' },
	{ value: '9541#CNO#P', label: 'Peones de la pesca' },
	{ value: '9542#CNO#P', label: 'Peones de la acuicultura' },
	{ value: '9543#CNO#P', label: 'Peones forestales y de la caza' },
	{ value: '9601#CNO#P', label: 'Peones de obras públicas' },
	{ value: '9602#CNO#P', label: 'Peones de la construcción de edificios' },
	{ value: '9603#CNO#P', label: 'Peones de la minería, canteras y otras industrias extractivas' },
	{ value: '9700#CNO#P', label: 'Peones de las industrias manufactureras' },
	{ value: '9811#CNO#P', label: 'Peones del transporte de mercancías y descargadores' },
	{
		value: '9812#CNO#P',
		label: 'Conductores de vehículos de tracción animal para el transporte de personas y similares'
	},
	{ value: '9820#CNO#P', label: 'Reponedores' },
	{ value: '0011#CNO#Q', label: 'Oficiales de las fuerzas armadas' },
	{ value: '0012#CNO#Q', label: 'Suboficiales de las fuerzas armadas' },
	{ value: '0020#CNO#Q', label: 'Tropa y marinería de las fuerzas armadas' }
];
